import React, { useEffect, useRef, useState } from 'react'
import { getVesselList } from '../../Management/core/_requests'
import { toast } from 'react-toastify'
import { showErrorToast } from '../../../shared/utils/apiErrorMessage'
import { Vessel } from '../../operations/core/_models'
import { fetchAccessibleVesselsForCurrentUser, normalizeAccessibleVessels } from '../../../shared/access/accessibleVessels'
import {
  getRanks,
  createCrew,
  getCompanyAdminList,
  getCompanyList,
  createCrewDocument,
  updateCrewDocument,
  getCrewDocument,
  updateCrew,
  getAcademicDetails,
  createAcademicDetails,
  updateAcademicDetails,
  getWatchkeepingCertificates,
  createWatchkeepingCertificate,
  updateWatchkeepingCertificate,
  getNextOfKin, createNextOfKin, updateNextOfKin,
  getBankingDetails, createBankingDetails, updateBankingDetails,
  getCourseCertificates,
  createCourseCertificate,
  updateCourseCertificate,
  getSeaServices,
  createSeaService,
  updateSeaService,
  deleteSeaService,
  getAdditionalDetails, updateAdditionalDetails, createAdditionalDetails,
  initiateCrewOnboarding,
  checkCrewNtbe,
} from '../core/_requests'
import {
  Rank,
  CompanyAdmin,
  Company,
  CrewDocumentResponse,
  CrewDocumentForm,
  AcademicQualificationRequest,
  AcademicQualificationResponse,
  WatchkeepingCertificateRequest,
  WatchkeepingCertificateResponse,
  NextOfKinRequest, NextOfKinResponse,
  BankingDetailsRequest, BankingDetailsResponse,
  CourseCertificate,
  CourseCertificateResponse,
  SeaServiceRequest, SeaServiceResponse,
  AdditionalDetailsResponse, AdditionalDetailsRequest,
  Reference,
  Crew
} from '../core/_models'
import { CrewFlagDocument } from '../core/_models'
import { getFlagDocuments } from '../core/_requests'

import { resolveCrewCreateOwnership } from '../../Crewing/core/crewOwnership'
import { resolveEffectiveBehaviorType } from '../../Management/core/adminActorContext'
import { useAuth } from '../../auth'
import { KTSVG } from '../../../../_metronic/helpers'
import PersonalData from './ApplicationForms/PersonalData'
import AcademicBackground from './ApplicationForms/AcademicBackground'
import CoursesCertificates from './ApplicationForms/CoursesCertificates'
import Documents from './ApplicationForms/Documents'
import NextOfKin from './ApplicationForms/NextOfKin'
import OtherDetails from './ApplicationForms/OtherDetails'
import SeaService from './ApplicationForms/SeaService'
import WatchkeepingCertificates from './ApplicationForms/WatchkeepingCertificates'
import FlagDocuments from './ApplicationForms/Flag'
import BankingDetails from './ApplicationForms/BankingDetails'
import CrewMatrixProfileModal, { isCrewMatrixRankAllowed } from './CrewMatrixProfileModal'

export const isValidEmailDomain = (emailStr: string): boolean => {
  if (!emailStr || !emailStr.trim()) return false
  const trimmed = emailStr.trim().toLowerCase()
  const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,24}$/
  if (!emailRegex.test(trimmed)) return false
  const parts = trimmed.split('@')
  if (parts.length !== 2) return false
  const domain = parts[1]
  if (!domain || domain.startsWith('.') || domain.endsWith('.') || domain.includes('..')) return false
  const domainParts = domain.split('.')
  if (domainParts.length < 2) return false
  for (const part of domainParts) {
    if (!part || !/^[a-z0-9-]+$/.test(part) || part.startsWith('-') || part.endsWith('-')) return false
  }
  const tld = domainParts[domainParts.length - 1]
  return !!tld && /^[a-z]{2,24}$/.test(tld)
}

// Top of file (after imports)
const TABS = [
  'personal',
  'documents',
  'academic',
  'watchkeeping',
  'kin',
  'banking',
  'courses',
  'seaService',
  'flagDocs',
  'other',
  'crewMatrix',
] as const
type TabKey = typeof TABS[number]
const DRAFT_KEY = 'addCrewWizardDraft_v1'
const app_link = process.env.REACT_APP_URL;
const nextTab = (current: TabKey): TabKey => {
  const i = TABS.indexOf(current)
  return TABS[Math.min(i + 1, TABS.length - 1)]
}
const prevTab = (current: TabKey): TabKey => {
  const i = TABS.indexOf(current)
  return TABS[Math.max(i - 1, 0)]
}
//watch keeping certs
const certificateDetails = [
  'Deck Watch keeping Regulation II/4',
  'Able Seafarer Deck Regulation II/5 (COP)',
  'Engine Room Watch keeping III/4',
  'Able Seafarer Engine Regulation III/5 (COP)',
]
//courses and certificates
const courseCertificateDetails = [
  'Personal Survival & Social Responsibility (PSSR)',
  'Proficiency in Survival Craft & Rescue Boat (PSCRB)',
  'Proficiency in Survival Technique (PST)',
  'Advanced Fire Fighting (AFF)/ Fire Prevention and Fire Fighting (FPFF)',
  'Elementary First Aid (EFA)/ Medical First Aid (MFA)/ Medicare',
  'STSDSD / SSO Course',
  'High Voltage Training',
  'Radar Observer / ARPA',
  'Radar Simulator (RANSCO) / ENS',
  'LCHS',
  'Ship Safety Officer',
  'Oil Tanker Familiarization (OTFC)/Advance Training for Cargo operation(TASCO)',
  'Chemical Tanker Familiarization (CTFC)',
  'Gas Familiarization (GTFC)',
  'Chemical Tanker Safety (CHEMCO)',
  'Gas Tanker Safety (GASCO)',
  'Bridge Team Management (BTM)/Bridge Resource Management (BRM)',
  'Engine Room Simulator (ERS)',
  'ECDIS-Generic',
  'ECDIS-Type Specific',
  'Any Value Added Course/Company Specific Course',
  'Yellow Fever',
  'Refresher and Updating Training (Up gradation course) for Deck Officers',
  'Refresher and Updating Training for Engineer Officers',
  'Add. Training if any',
];

const bloodGroupOptions = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']

interface Props {
  isOpen: boolean
  onClose: () => void
  onCrewAdded: (payload: { password: string; link: string; created: Crew }) => void
}

interface Certification {
  documentName: string
  file: File | null
}

const getCategoryForCourse = (certificateName: string): string => {
  if (
    [
      'Personal Survival & Social Responsibility (PSSR)',
      'Proficiency in Survival Craft & Rescue Boat (PSCRB)',
      'Proficiency in Survival Technique (PST)',
      'Advanced Fire Fighting (AFF)/ Fire Prevention and Fire Fighting (FPFF)',
      'Elementary First Aid (EFA)/ Medical First Aid (MFA)/ Medicare',
      'STSDSD / SSO Course',
      'High Voltage Training',
      'Radar Observer / ARPA',
      'Radar Simulator (RANSCO) / ENS',
      'LCHS',
      'Ship Safety Officer',
    ].includes(certificateName)
  ) {
    return 'STCW Certificates';
  } else if (
    [
      'Oil Tanker Familiarization (OTFC)/Advance Training for Cargo operation(TASCO)',
      'Chemical Tanker Familiarization (CTFC)',
      'Gas Familiarization (GTFC)',
      'Chemical Tanker Safety (CHEMCO)',
      'Gas Tanker Safety (GASCO)',
    ].includes(certificateName)
  ) {
    return 'Tanker Courses';
  } else if (
    [
      'Bridge Team Management (BTM)/Bridge Resource Management (BRM)',
      'Engine Room Simulator (ERS)',
      'ECDIS-Generic',
      'ECDIS-Type Specific',
      'Any Value Added Course/Company Specific Course',
      'Yellow Fever',
    ].includes(certificateName)
  ) {
    return 'Navigation & Main Engine Training';
  } else {
    return 'Revalidation Course';
  }
};

const normalizeCourseCertificate = (
  certificate: CourseCertificate,
  fallbackCategory?: string
): CourseCertificate => {
  const certificateName = (certificate.certificateName || '').trim()
  const category =
    certificate.category ||
    (certificateName
      ? getCategoryForCourse(certificateName)
      : fallbackCategory || 'Revalidation Course')

  return {
    id: certificate.id,
    crewId: certificate.crewId,
    certificateName,
    category,
    certificateNumber: certificate.certificateNumber || '',
    dateOfIssue: certificate.dateOfIssue || '',
    dateOfExpiry: certificate.dateOfExpiry || '',
    issuedBy: certificate.issuedBy || '',
    filePath: certificate.filePath || null,
    fileName: certificate.fileName || null,
    uploadedAt: certificate.uploadedAt || null,
  }
}

const buildCourseCertificateState = (source: CourseCertificate[] = []): CourseCertificate[] => {
  const normalizedSource = source.map((certificate) => normalizeCourseCertificate(certificate))

  const defaultRows = courseCertificateDetails.map((certificateName) => {
    const existingCert = normalizedSource.find((cert) => cert.certificateName === certificateName)
    if (existingCert) {
      return normalizeCourseCertificate(existingCert, getCategoryForCourse(certificateName))
    }
    return normalizeCourseCertificate(
      {
        certificateName,
        category: getCategoryForCourse(certificateName),
      },
      getCategoryForCourse(certificateName)
    )
  })

  const customRows = normalizedSource.filter((certificate) => {
    if (!certificate.certificateName) {
      return true
    }
    return !courseCertificateDetails.includes(certificate.certificateName)
  })

  return [...defaultRows, ...customRows]
}

const AddCrewModal: React.FC<Props> = ({ onClose, isOpen, onCrewAdded }) => {
  const [activeTab, setActiveTab] = useState('personal')
  const [selectedVessel, setSelectedVessel] = useState<Vessel | null>(null)
  const [vessels, setVessels] = useState<Vessel[]>([])
  const [name, setName] = useState('')
  const [notes, setNotes] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState<Date | null>(null)
  const [nationality, setNationality] = useState('')
  const [department, setDepartment] = useState('')
  const [ranks, setRanks] = useState<Rank[]>([])
  // const [selectedRankId, setSelectedRankId] = useState<number | ''>('')
  const [presentRankId, setPresentRankId] = useState<number | ''>('')
  const [rankAppliedForId, setRankAppliedForId] = useState<number | ''>('')
  const [employeeId, setEmployeeId] = useState('')
  const [bloodGroup, setBloodGroup] = useState('')
  const [companies, setCompanies] = useState<Company[]>([])
  const [companiesbyAdmin, setCompaniesByAdmin] = useState<Company[]>([])
  const [contactNumber, setContactNumber] = useState('')
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [isSubmittingTab, setIsSubmittingTab] = useState(false)
  // clears the top-of-form error banner
  const clearTopError = React.useCallback(() => {
    setError('');
  }, []);
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({})
  const [certifications, setCertifications] = useState<Certification[]>([
    { documentName: '', file: null },
  ])
  const [documents, setDocuments] = useState<Certification[]>([{ documentName: '', file: null }])
  const [academicBackgrounds, setAcademicBackgrounds] = useState<AcademicQualificationRequest[]>([
    {
      qualification: '',
      institutionName: '',
      boardOrUniversity: '',
      dateOfPassing: '',
      gradeOrPercentage: '',
      englishProficiency: '',
    },
  ])
  const [watchkeepingCertificates, setWatchkeepingCertificates] = useState<
    WatchkeepingCertificateRequest[]
  >(
    certificateDetails.map((detail) => ({
      certificateDetails: detail,
      certificateNo: '',
      dateOfIssue: '',
      placeOfIssue: '',
      validUntil: '',
    }))
  )
  const [nextOfKin, setNextOfKin] = useState<NextOfKinRequest>({
    crewId: 0,
    civilStatus: null,
    fullName: '',
    relationship: '',
    address: '',
    pinCode: '',
    phoneStdCode: '',
    phoneNumber: '',
  });
  const [courseCertificates, setCourseCertificates] = useState<CourseCertificate[]>(
    buildCourseCertificateState()
  );
  const [seaServices, setSeaServices] = useState<SeaServiceRequest[]>([
    {
      serialNo: 1,
      companyName: '',
      vesselName: '',
      typeOfVesselFlag: '',
      grtdrt: '',
      engineType: '',
      kwtBhp: '',
      rank: '',
      fromDate: '',
      toDate: '',
      totalMonthsDays: '',
      reasonForSignOff: '',
    },
  ]);
  const [additionalDetails, setAdditionalDetails] = useState<AdditionalDetailsRequest>({
    crewId: 0,
    criminalCaseInvolved: false,
    criminalCaseDetails: '',
    certificateSuspendedRevoked: false,
    certificateSuspendedRevokedDetails: '',
    hasMedicalConditions: false,
    medicalConditionsDetails: '',
    habitualUseDrugsAlcohol: false,
    habitualUseDetails: '',
    workedWithMultinational: false,
    multinationalNationalities: '',
    referralSource: null,
    referralDetails: '',
    pumpExperienceFramoMonths: null,
    pumpExperienceCopMonths: null,
    drydockingExperience: false,
    drydockingRank: '',
    newConstructionExperience: false,
    newConstructionRank: '',
    incidentInvolvement: false,
    incidentDetails: '',
    courtOfEnquiryInvolvement: false,
    courtOfEnquiryDetails: '',
    references: '[]',
    declarationMedicalExam: false,
    declarationMedicalDecision: false,
    declarationNoCriminal: false,
    declarationDocumentsValid: false,
    declarationNotEmployed: false,
    declarationNoAgents: false,
    availabilityDate: '',
    applicantName: '',
    applicantDate: '',
    hasReferenceData: false,
  });
  const [references, setReferences] = useState<Reference[]>([{ srNo: 1, companyName: '', pic: '', designation: '', phoneNo: '' }]);

  const [familyName, setFamilyName] = useState('')
  const [telNo, setTelNo] = useState('')
  const [alternateMobNo, setAlternateMobNo] = useState('')
  const [skypeId, setSkypeId] = useState('')
  const [maritalStatus, setMaritalStatus] = useState('')
  const [heightCms, setHeight] = useState<number>(0)
  const [weightKgs, setWeight] = useState<number>(0)
  const [bmiIndex, setBmiIndex] = useState<number>(0)
  const [willingToAcceptLowerRank, setWillingToAcceptLowerRank] = useState<boolean>(false)
  const [boilerSuitSize, setBoilerSuitSize] = useState('')
  const [shoeSize, setShoeSize] = useState('')
  const [address, setAddress] = useState('')
  const [placeOfBirth, setPlaceOfBirth] = useState('')
  const [dateOfAvailability, setDateOfAvailability] = useState<Date | null>(null)
  const [dateOfJoining, setDateOfJoining] = useState<Date | null>(() => new Date())
  const [crewId, setCrewId] = useState<number | null>(null)
  const [documentForm, setDocumentForm] = useState<CrewDocumentForm>({})
  const [existingDocument, setExistingDocument] = useState<CrewDocumentResponse | null>(null)
  const [existingAcademicDetails, setExistingAcademicDetails] = useState<
    AcademicQualificationResponse[]
  >([])
  const [existingWatchkeepingCertificates, setExistingWatchkeepingCertificates] = useState<
    WatchkeepingCertificateResponse[]
  >([])
  const [existingNextOfKin, setExistingNextOfKin] = useState<NextOfKinResponse | null>(null);
  const [existingBankingDetails, setExistingBankingDetails] = useState<BankingDetailsResponse | null>(null);
  const [existingCourseCertificates, setExistingCourseCertificates] = useState<
    CourseCertificateResponse[]
  >([]);
  const [existingSeaServices, setExistingSeaServices] = useState<SeaServiceResponse[]>([]);
  const [existingAdditionalDetails, setExistingAdditionalDetails] = useState<AdditionalDetailsResponse | null>(null);
  const [existingFlagDocuments, setExistingFlagDocuments] = useState<CrewFlagDocument[] | null>(null)
  const [bankingDetails, setBankingDetails] = useState<any>({
    crewId: 0,
    nameOfBeneficiary: '',
    accountNumber: '',
    bankName: '',
    branchName: '',
    branchCode: '',
    ifscRtgsType: 'IFSC',
    ifscRtgsCode: '',
    swiftIandi: '',
    bankAddress: '',
    accountCurrency: '',
    otherCurrency: '',
    salaryCurrency: '',
    salaryOtherCurrency: '',
    remarks: '',
    basicWages: null,
    fixedOvertime109Hrs: null,
    leaveWages9DaysPerMonth: null,
    subSmb: null,
    tradeAllowance: null,
    otherAllowance: null,
    ownersLoyaltyBonus: null,
    rejoiningBonus: null,
    overtimeRate: null,
    unionSocialDues: 'As per CBA',
    cashAdvanceFromOffice: null,
    deductionBond: null,
    deductionInternetCard: null,
    otherDeductions: null,
    deductionsTotal: null,
    salary: null,
  })

  // Onboarding (Send Mail) states
  const [onboardingLoading, setOnboardingLoading] = useState(false)
  const [onboardingLink, setOnboardingLink] = useState<string | null>(null)
  const [showInvitePopup, setShowInvitePopup] = useState(false)
  const [onboardingSent, setOnboardingSent] = useState(false)
  const { currentUser, roleDetails, tenant } = useAuth()
  const roleEntityId = currentUser?.roleEntityId
  const roleId = currentUser?.role?.id ?? 0

  // unified CGA resolver
  const cgaId =
    currentUser?.companyGroupAdminId ?? currentUser?.companyGroupAdmin?.id ??
    null

  // unified Company resolver
  const caId =
    currentUser?.companyAdminId ?? currentUser?.companyAdmin?.id ??
    null

  // OPERATOR flavors
  const isOperator = roleId === 6
  const isSuperadminOperator = isOperator && cgaId == null && caId == null // acts like Superadmin
  const isGroupOperator = isOperator && cgaId != null && caId == null // acts like Company Group Admin
  const isCompanyOperator = isOperator && caId != null // acts like Company Admin
  const canSuperadminSeeCrewMatrix = roleId === 1 || isSuperadminOperator

  // NEW: flags that PersonalData consumes (keep names same as EditCrewModal)
  const operatorActsLikeSuperadmin = isSuperadminOperator
  const operatorActsLikeGroupAdmin = isGroupOperator

  const [companyAdmins, setCompanyAdmins] = useState<CompanyAdmin[]>([])
  const [selectedCompany, setSelectedCompany] = useState<{ id: number; name: string }>({
    id: 0,
    name: '',
  })
  const [selectedCompanyAdmin, setSelectedCompanyAdmin] = useState<{ id: number; name: string }>({
    id: 0,
    name: '',
  })

  const [generatedUsername, setGeneratedUsername] = useState<string>('');

  const [generatedPassword, setGeneratedPassword] = useState<string>('')

  // Always start with fresh creds on a new Add Crew session
  useEffect(() => {
    if (isOpen && !crewId) {
      setGeneratedUsername('')
      setGeneratedPassword('')
    }
  }, [isOpen, crewId])


  const [loginLink, setLoginLink] = useState<string>('')

  // state // Track “saved” status and snapshots for dirty-check
  const [savedTabs, setSavedTabs] = useState<Record<TabKey, boolean>>({
    personal: false,
    documents: false,
    academic: false,
    watchkeeping: false,
    kin: false,
    courses: false,
    seaService: false,
    flagDocs: false,
    banking: false,
    other: false,
    crewMatrix: false,
  })

  const [personalSnapshot, setPersonalSnapshot] = useState<string>('')
  const [documentSnapshot, setDocumentSnapshot] = useState<string>('')
  const [academicSnapshot, setAcademicSnapshot] = useState<string>('')
  const [watchkeepingSnapshot, setWatchkeepingSnapshot] = useState<string>('')
  const [nextOfKinSnapshot, setNextOfKinSnapshot] = useState<string>('');
  const [courseCertificatesSnapshot, setCourseCertificatesSnapshot] = useState<string>(
    JSON.stringify(buildCourseCertificateState())
  );
  const [seaServiceSnapshot, setSeaServiceSnapshot] = useState<string>('');
  const [bankingDetailsSnapshot, setBankingDetailsSnapshot] = useState<string>('');
  const [additionalDetailsSnapshot, setAdditionalDetailsSnapshot] = useState<string>('');

  useEffect(() => {
    if (!isOpen) return;
    // wipe out any stale top error when the modal opens
    clearTopError();
  }, [isOpen, clearTopError]);


  const coreLocked = !!crewId && savedTabs.personal;

  // Put this near other state:
  const personalForm = React.useMemo(
    () => ({
      name,
      dateOfBirth,
      nationality,
      department,
      contactNumber,
      email,
      presentRankId,
      rankAppliedForId,
      bloodGroup,
      familyName,
      telNo,
      alternateMobNo,
      skypeId,
      maritalStatus,
      heightCms,
      weightKgs,
      bmiIndex,
      willingToAcceptLowerRank,
      boilerSuitSize,
      shoeSize,
      address,
      placeOfBirth,
      dateOfAvailability,
      dateOfJoining,
      selectedCompany,
      selectedCompanyAdmin,
      employeeId,
      cdcNumber: documentForm.cdcNumber,
      cdcPlaceOfIssue: documentForm.cdcPlaceOfIssue,
      cdcIssueDate: documentForm.cdcIssueDate,
      cdcExpiryDate: documentForm.cdcExpiryDate,
      unionMembershipNo: documentForm.unionMembershipNo,
    }),
    [
      name,
      dateOfBirth,
      nationality,
      department,
      contactNumber,
      email,
      presentRankId,
      rankAppliedForId,
      bloodGroup,
      familyName,
      telNo,
      alternateMobNo,
      skypeId,
      maritalStatus,
      heightCms,
      weightKgs,
      bmiIndex,
      willingToAcceptLowerRank,
      boilerSuitSize,
      shoeSize,
      address,
      placeOfBirth,
      dateOfAvailability,
      dateOfJoining,
      selectedCompany,
      selectedCompanyAdmin,
      employeeId,
      documentForm.cdcNumber,
      documentForm.cdcPlaceOfIssue,
      documentForm.cdcIssueDate,
      documentForm.cdcExpiryDate,
      documentForm.unionMembershipNo,
    ]
  )

  const companyAwarenessName = React.useMemo(() => {
    const selectedCompanyName = selectedCompany?.name?.trim()
    if (selectedCompanyName) {
      return selectedCompanyName
    }

    const matchedCompany = [...companies, ...companiesbyAdmin].find((company) => company.id === selectedCompany?.id)
    if (matchedCompany?.name?.trim()) {
      return matchedCompany.name.trim()
    }

    const selectedAdminName = selectedCompanyAdmin?.name?.trim()
    if (selectedAdminName) {
      return selectedAdminName
    }

    const matchedAdmin = companyAdmins.find((admin) => admin.id === selectedCompanyAdmin?.id)
    if (matchedAdmin?.name?.trim()) {
      return matchedAdmin.name.trim()
    }

    return 'Peninsular Maritime India Pvt Ltd'
  }, [selectedCompany, selectedCompanyAdmin, companies, companiesbyAdmin, companyAdmins])

  const [isFlagsDirty, setIsFlagsDirty] = useState(false)
  // Ref to call saveAll() on FlagDocuments tab
  const flagDocsRef = useRef<{ saveAll: () => Promise<boolean> } | null>(null)

  const academicForm = React.useMemo(() => academicBackgrounds, [academicBackgrounds])
  const watchkeepingForm = React.useMemo(() => watchkeepingCertificates, [watchkeepingCertificates])
  const nextOfKinForm = React.useMemo(() => nextOfKin, [nextOfKin]);
  const coursesForm = React.useMemo(() => courseCertificates, [courseCertificates]);
  const seaServiceForm = React.useMemo(() => seaServices, [seaServices]);
  const additionalDetailsForm = React.useMemo(() => ({ ...additionalDetails, references }), [additionalDetails, references]);
  const matrixRank = React.useMemo(() => {
    const selectedRankId = Number(presentRankId || 0)
    return ranks.find((rank) => rank.id === selectedRankId) ?? null
  }, [presentRankId, ranks])
  const showCrewMatrixForRank = React.useMemo(
    () => isCrewMatrixRankAllowed(matrixRank?.rank),
    [matrixRank]
  )
  const showCrewMatrix = canSuperadminSeeCrewMatrix || showCrewMatrixForRank
  const matrixCrewRecord = React.useMemo(
    () => ({
      id: crewId ?? 0,
      crewId: crewId ?? 0,
      name: name || '',
      crewName: name || '',
      nationality: nationality || '',
      rankId: Number(presentRankId || 0) || undefined,
      rankInfo: matrixRank ? { id: matrixRank.id, rank: matrixRank.rank } : undefined,
      rank: matrixRank?.rank || '',
      dateOfAvailability: dateOfAvailability
        ? new Date(dateOfAvailability).toISOString().slice(0, 10)
        : additionalDetails?.availabilityDate || '',
      signOnDate: (additionalDetails as any)?.signOnDate || (existingAdditionalDetails as any)?.signOnDate || '',
      ...(documentForm ?? {}),
      ...(existingDocument ?? {}),
      crewDocuments: {
        ...(documentForm ?? {}),
        ...(existingDocument ?? {}),
      },
      additionalInfo: {
        ...(existingAdditionalDetails ?? {}),
        ...(additionalDetails ?? {}),
      },
      academicQualifications: Array.isArray(academicBackgrounds) ? academicBackgrounds : [],
      courses: Array.isArray(courseCertificates) ? courseCertificates : [],
      seaServiceHistory: Array.isArray(seaServices) ? seaServices : [],
    }),
    [
      crewId,
      name,
      nationality,
      presentRankId,
      matrixRank,
      dateOfAvailability,
      additionalDetails,
      existingAdditionalDetails,
      academicBackgrounds,
      documentForm,
      existingDocument,
      courseCertificates,
      seaServices,
    ]
  )
  const isPersonalDirty = React.useMemo(
    () => JSON.stringify(personalForm) !== personalSnapshot,
    [personalForm, personalSnapshot]
  )

  const isDocumentDirty = React.useMemo(
    () => JSON.stringify(documentForm) !== documentSnapshot,
    [documentForm, documentSnapshot]
  )

  const isAcademicDirty = React.useMemo(
    () => JSON.stringify(academicForm) !== academicSnapshot,
    [academicForm, academicSnapshot]
  )

  const isWatchkeepingDirty = React.useMemo(
    () => JSON.stringify(watchkeepingForm) !== watchkeepingSnapshot,
    [watchkeepingForm, watchkeepingSnapshot]
  )

  const isNextOfKinDirty = React.useMemo(
    () => JSON.stringify(nextOfKinForm) !== nextOfKinSnapshot,
    [nextOfKinForm, nextOfKinSnapshot]
  );
  const isCoursesDirty = React.useMemo(
    () => JSON.stringify(coursesForm) !== courseCertificatesSnapshot,
    [coursesForm, courseCertificatesSnapshot]
  );
  const isSeaServiceDirty = React.useMemo(
    () => JSON.stringify(seaServiceForm) !== seaServiceSnapshot,
    [seaServiceForm, seaServiceSnapshot]
  );
  const isBankingDetailsDirty = React.useMemo(
    () => JSON.stringify(bankingDetails) !== bankingDetailsSnapshot,
    [bankingDetails, bankingDetailsSnapshot]
  );
  const isAdditionalDetailsDirty = React.useMemo(
    () => JSON.stringify(additionalDetailsForm) !== additionalDetailsSnapshot,
    [additionalDetailsForm, additionalDetailsSnapshot]
  );

  const persistDraft = React.useCallback(() => {
    const payload = {
      activeTab,
      crewId,
      personalForm,
      documentForm,
      academicForm,
      watchkeepingForm,
      nextOfKinForm,
      coursesForm,
      seaServiceForm,
      additionalDetailsForm,
      savedTabs,
      ts: Date.now(),
    }
    localStorage.setItem(DRAFT_KEY, JSON.stringify(payload))
  }, [activeTab, crewId, personalForm, documentForm, academicForm, watchkeepingForm, nextOfKinForm, coursesForm, seaServiceForm, additionalDetailsForm, savedTabs])

  // Save draft whenever something significant changes            
  useEffect(() => {
    if (isOpen) persistDraft()
  }, [isOpen, persistDraft])



  // Restore draft on open                                    
  useEffect(() => {
    if (!isOpen) return
    const raw = localStorage.getItem(DRAFT_KEY)
    if (!raw) return

    try {
      const draft = JSON.parse(raw)
      // Check if draft has meaningful data
      const hasPersonalData =
        draft?.personalForm &&
        Object.values(draft.personalForm).some(
          (val) =>
            val !== '' &&
            val !== null &&
            val !== undefined &&
            (typeof val !== 'object' || Object.values(val).some((v) => v !== 0 && v !== ''))
        )
      // const hasDocumentData = draft?.documentForm && Object.values(draft.documentForm).some(val => val !== '' && val !== null && val !== undefined);
      if (
        hasPersonalData
        // || hasDocumentData
      ) {
        if (draft?.personalForm) {
          const p = draft.personalForm
          setName(p.name ?? '')
          setDateOfBirth(p.dateOfBirth ? new Date(p.dateOfBirth) : null)
          setNationality(p.nationality ?? '')
          setDepartment(p.department ?? '')
          setContactNumber(p.contactNumber ?? '')
          setEmail(p.email ?? '')
          setPresentRankId(p.presentRankId ?? '')
          setRankAppliedForId(p.rankAppliedForId ?? '')
          setBloodGroup(p.bloodGroup ?? '')
          setFamilyName(p.familyName ?? '')
          setTelNo(p.telNo ?? '')
          setAlternateMobNo(p.alternateMobNo ?? '')
          setSkypeId(p.skypeId ?? '')
          setMaritalStatus(p.maritalStatus ?? '')
          setHeight(p.heightCms ?? 0)
          setWeight(p.weightKgs ?? 0)
          setBmiIndex(p.bmiIndex ?? 0)
          setWillingToAcceptLowerRank(!!p.willingToAcceptLowerRank)
          setBoilerSuitSize(p.boilerSuitSize ?? '')
          setShoeSize(p.shoeSize ?? '')
          setAddress(p.address ?? '')
          setPlaceOfBirth(p.placeOfBirth ?? '')
          setDateOfAvailability(p.dateOfAvailability ? new Date(p.dateOfAvailability) : null)
          setDateOfJoining(p.dateOfJoining ? new Date(p.dateOfJoining) : null)
          setSelectedCompany(p.selectedCompany ?? { id: 0, name: '' })
          setSelectedCompanyAdmin(p.selectedCompanyAdmin ?? { id: 0, name: '' })
        }
        if (draft?.documentForm) setDocumentForm(draft.documentForm)
        if (draft?.academicForm) setAcademicBackgrounds(draft.academicForm)
        if (draft?.watchkeepingForm) setWatchkeepingCertificates(draft.watchkeepingForm)
        if (draft?.nextOfKinForm) setNextOfKin(draft.nextOfKinForm);
        if (draft?.coursesForm) setCourseCertificates(buildCourseCertificateState(draft.coursesForm));
        if (draft?.seaServiceForm) setSeaServices(draft.seaServiceForm);
        if (draft?.additionalDetailsForm) {
          setAdditionalDetails(draft.additionalDetailsForm);
          setReferences(JSON.parse(draft.additionalDetailsForm.references || '[]'));
          setSeaServiceSnapshot(JSON.stringify(draft?.seaServiceForm ?? []));
          setAdditionalDetailsSnapshot(JSON.stringify(draft?.additionalDetailsForm ?? {}));
        }
        if (draft?.savedTabs) setSavedTabs(draft.savedTabs)
        if (typeof draft?.crewId === 'number') setCrewId(draft.crewId)
        if (draft?.activeTab && TABS.includes(draft.activeTab)) {
          setActiveTab(draft.activeTab as TabKey)
        }
        // establish snapshots so we don’t show “dirty” on restored data    
        setPersonalSnapshot(JSON.stringify(draft?.personalForm ?? {}))
        setDocumentSnapshot(JSON.stringify(draft?.documentForm ?? {}))
        setAcademicSnapshot(JSON.stringify(draft?.academicForm ?? []))
        setWatchkeepingSnapshot(JSON.stringify(draft?.watchkeepingForm ?? []))
        setNextOfKinSnapshot(JSON.stringify(draft?.nextOfKinForm ?? {}));
        setCourseCertificatesSnapshot(JSON.stringify(buildCourseCertificateState(draft?.coursesForm ?? [])));

        // toast.info('Restored in-progress application');
      }
    } catch { }
  }, [isOpen])

  // REPLACE the whole function with this:
  const safeSetActiveTab = (tab: TabKey) => {
    // clear any stale “Failed to save …” message when navigating
    clearTopError();

    if (tab === 'crewMatrix' && !showCrewMatrix) {
      setActiveTab('other')
      return
    }

    // Hard rule: you can’t leave Personal until a crew is created.
    if (!crewId && tab !== 'personal') {
      //if (false && !crewId && tab !== 'personal') {
      toast.error('Please save "Personal Data" first');
      setActiveTab('personal');
      return;
    }
    // Once a crewId exists, allow free navigation to any tab (even if previous tabs are unsaved).
    setActiveTab(tab);
  };

  useEffect(() => {
    if (!showCrewMatrix && activeTab === 'crewMatrix') {
      setActiveTab('other')
    }
  }, [showCrewMatrix, activeTab])


  useEffect(() => {
    fetchRanks()
    fetchCompanyAdmins()
    fetchCompanies()
  }, [])

  useEffect(() => {
    if (activeTab === 'documents' && crewId) {
      checkExistingDocument()
    }
    if (activeTab === 'academic' && crewId) {
      checkExistingAcademicDetails()
    }
    if (activeTab === 'watchkeeping' && crewId) {
      checkExistingWatchkeepingCertificates()
    }
    if (activeTab === 'kin' && crewId) {
      checkExistingNextOfKin();
    }
    if (activeTab === 'courses' && crewId) {
      checkExistingCourseCertificates();
    }
    if (activeTab === 'banking' && crewId) {
      checkExistingBankingDetails();
    }
    if (activeTab === 'seaService' && crewId) {
      checkExistingSeaServices();
    }
    if (activeTab === 'flagDocs' && crewId) {  // ← Added this
      checkExistingFlagDocuments()
    }
    // if (activeTab === 'other' && crewId) {
    //     checkExistingAdditionalDetails();
    //   }
  }, [activeTab, crewId])

  const fetchRanks = async () => {
    try {
      const ranksList = await getRanks()
      setRanks(ranksList)
    } catch (err) {
      console.error('Failed to fetch ranks:', err)
    }
  }

  const fetchCompanyAdmins = async () => {
    try {
      const companyAdminsList = await getCompanyAdminList()
      setCompanyAdmins(companyAdminsList)
    } catch (err) {
      console.error('Failed to fetch company admins:', err)
    }
  }

  const fetchCompanies = async () => {
    try {
      const companyList = await getCompanyList();

      // For Company (5) or group-scoped Operator: filter by their CGA.
      // For Superadmin (1) or Superadmin-Operator: don't pre-filter; list empty until a CGA is chosen in UI.
      let groupIdForFilter: number | null = null;
      if (roleId === 5 || isGroupOperator) {
        groupIdForFilter = Number((roleId === 5 ? roleEntityId : cgaId) ?? 0);
      } else {
        groupIdForFilter = null; // Superadmin & Superadmin-operator & Subcompany don't use this direct list
      }

      const activeCompanies = groupIdForFilter
        ? companyList.filter(
          (company) => company.active === true && company.cga?.id === groupIdForFilter
        )
        : [];

      setCompanies(activeCompanies);
    } catch (error) {
      console.error('Failed to fetch company list:', error);
    }
  };

  useEffect(() => {
    fetchVessels()
    getRanks().then(setRanks).catch(console.error)
  }, [])

  const checkExistingDocument = async () => {
    try {
      const resp = await getCrewDocument(crewId!)

      // Accept “exists” only if there’s a numeric id
      if (resp && typeof resp.id === 'number') {
        setExistingDocument(resp)
        // If resp already matches your form shape, keep this:
        setDocumentForm(resp)
        setDocumentSnapshot(JSON.stringify(resp))
      } else {
        setExistingDocument(null)
        // Only reset documentForm if no draft data exists
        const raw = localStorage.getItem(DRAFT_KEY)
        const draft = raw ? JSON.parse(raw) : null
        if (
          !draft?.documentForm ||
          Object.values(draft.documentForm).every(
            (val) => val === '' || val === null || val === undefined
          )
        ) {
          setDocumentForm({})
          setDocumentSnapshot(JSON.stringify({}))
        }
      }
    } catch (error) {
      console.error('No existing document found:', error)
      setExistingDocument(null)
      // Only reset documentForm if no draft data exists
      const raw = localStorage.getItem(DRAFT_KEY)
      const draft = raw ? JSON.parse(raw) : null
      if (
        !draft?.documentForm ||
        Object.values(draft.documentForm).every(
          (val) => val === '' || val === null || val === undefined
        )
      ) {
        setDocumentForm({})
        setDocumentSnapshot(JSON.stringify({}))
      }
    }
  }

  const emptySeaServiceRow = (serialNo: number): SeaServiceRequest => ({
    serialNo,
    companyName: '',
    vesselName: '',
    typeOfVesselFlag: '',
    grtdrt: '',
    engineType: '',
    kwtBhp: '',
    rank: '',
    fromDate: '',
    toDate: '',
    totalMonthsDays: '',
    reasonForSignOff: '',
  });

  const checkExistingAcademicDetails = async () => {
    try {
      const resp = await getAcademicDetails(crewId!)
      if (resp && resp.length > 0 && resp.some((item) => item.id)) {
        setExistingAcademicDetails(resp)
        setAcademicBackgrounds(
          resp.map((item) => ({
            id: item.id,
            qualification: item.qualification || '',
            institutionName: item.institutionName || '',
            boardOrUniversity: item.boardOrUniversity || '',
            dateOfPassing: item.dateOfPassing || '',
            gradeOrPercentage: item.gradeOrPercentage || '',
            englishProficiency: item.englishProficiency || '',
          }))
        )
        setAcademicSnapshot(JSON.stringify(resp))
      } else {
        setExistingAcademicDetails([])
        const raw = localStorage.getItem(DRAFT_KEY)
        const draft = raw ? JSON.parse(raw) : null
        if (
          !draft?.academicForm ||
          draft.academicForm.every((item: any) =>
            Object.values(item).every((val) => val === '' || val === null || val === undefined)
          )
        ) {
          setAcademicBackgrounds([
            {
              qualification: '',
              institutionName: '',
              boardOrUniversity: '',
              dateOfPassing: '',
              gradeOrPercentage: '',
              englishProficiency: '',
            },
          ])
          setAcademicSnapshot(JSON.stringify([]))
        }
      }
    } catch (error) {
      console.error('No existing academic details found:', error)
      setExistingAcademicDetails([])
      const raw = localStorage.getItem(DRAFT_KEY)
      const draft = raw ? JSON.parse(raw) : null
      if (
        !draft?.academicForm ||
        draft.academicForm.every((item: any) =>
          Object.values(item).every((val) => val === '' || val === null || val === undefined)
        )
      ) {
        setAcademicBackgrounds([
          {
            qualification: '',
            institutionName: '',
            boardOrUniversity: '',
            dateOfPassing: '',
            gradeOrPercentage: '',
            englishProficiency: '',
          },
        ])
        setAcademicSnapshot(JSON.stringify([]))
      } else {
        setAcademicBackgrounds(draft.academicForm)
        setAcademicSnapshot(JSON.stringify(draft.academicForm))
      }
    }
  }

  const checkExistingWatchkeepingCertificates = async () => {
    try {
      const resp = await getWatchkeepingCertificates(crewId!)
      if (resp && resp.length > 0 && resp.some((item) => item.id)) {
        setExistingWatchkeepingCertificates(resp)
        const updatedCertificates = certificateDetails.map((detail, index) => {
          const existingCert = resp.find((cert) => cert.certificateDetails === detail)
          return {
            certificateDetails: detail,
            certificateNo: existingCert?.certificateNo || '',
            dateOfIssue: existingCert?.dateOfIssue || '',
            placeOfIssue: existingCert?.placeOfIssue || '',
            validUntil: existingCert?.validUntil || '',
          }
        })
        setWatchkeepingCertificates(updatedCertificates)
        setWatchkeepingSnapshot(JSON.stringify(updatedCertificates))
      } else {
        setExistingWatchkeepingCertificates([])
        const raw = localStorage.getItem(DRAFT_KEY)
        const draft = raw ? JSON.parse(raw) : null
        if (
          !draft?.watchkeepingForm ||
          draft.watchkeepingForm.every((item: any) =>
            Object.values(item).every((val) => val === '' || val === null || val === undefined)
          )
        ) {
          setWatchkeepingCertificates(
            certificateDetails.map((detail) => ({
              certificateDetails: detail,
              certificateNo: '',
              dateOfIssue: '',
              placeOfIssue: '',
              validUntil: '',
            }))
          )
          setWatchkeepingSnapshot(
            JSON.stringify(
              certificateDetails.map((detail) => ({
                certificateDetails: detail,
                certificateNo: '',
                dateOfIssue: '',
                placeOfIssue: '',
                validUntil: '',
              }))
            )
          )
        } else {
          setWatchkeepingCertificates(draft.watchkeepingForm)
          setWatchkeepingSnapshot(JSON.stringify(draft.watchkeepingForm))
        }
      }
    } catch (error) {
      console.error('No existing watchkeeping certificates found:', error)
      setExistingWatchkeepingCertificates([])
      const raw = localStorage.getItem(DRAFT_KEY)
      const draft = raw ? JSON.parse(raw) : null
      if (
        !draft?.watchkeepingForm ||
        draft.watchkeepingForm.every((item: any) =>
          Object.values(item).every((val) => val === '' || val === null || val === undefined)
        )
      ) {
        setWatchkeepingCertificates(
          certificateDetails.map((detail) => ({
            certificateDetails: detail,
            certificateNo: '',
            dateOfIssue: '',
            placeOfIssue: '',
            validUntil: '',
          }))
        )
        setWatchkeepingSnapshot(
          JSON.stringify(
            certificateDetails.map((detail) => ({
              certificateDetails: detail,
              certificateNo: '',
              dateOfIssue: '',
              placeOfIssue: '',
              validUntil: '',
            }))
          )
        )
      } else {
        setWatchkeepingCertificates(draft.watchkeepingForm)
        setWatchkeepingSnapshot(JSON.stringify(draft.watchkeepingForm))
      }
    }
  }

  const checkExistingNextOfKin = async () => {
    try {
      const resp = await getNextOfKin(crewId!);
      if (resp && typeof resp.id === 'number') {
        setExistingNextOfKin(resp);
        setNextOfKin({
          crewId: crewId!,
          civilStatus: resp.civilStatus || null,
          fullName: resp.fullName || '',
          relationship: resp.relationship || '',
          address: resp.address || '',
          pinCode: resp.pinCode || '',
          phoneStdCode: resp.phoneStdCode || '',
          phoneNumber: resp.phoneNumber || '',
        });
        setNextOfKinSnapshot(JSON.stringify(resp));
      } else {
        setExistingNextOfKin(null);
        const raw = localStorage.getItem(DRAFT_KEY);
        const draft = raw ? JSON.parse(raw) : null;
        if (
          !draft?.nextOfKinForm ||
          Object.values(draft.nextOfKinForm).every(
            (val) => val === '' || val === null || val === undefined
          )
        ) {
          setNextOfKin({
            crewId: crewId!,
            civilStatus: null,
            fullName: '',
            relationship: '',
            address: '',
            pinCode: '',
            phoneStdCode: '',
            phoneNumber: '',
          });
          setNextOfKinSnapshot(JSON.stringify({}));
        }
      }
    } catch (error) {
      console.error('No existing next of kin found:', error);
      setExistingNextOfKin(null);
      const raw = localStorage.getItem(DRAFT_KEY);
      const draft = raw ? JSON.parse(raw) : null;
      if (
        !draft?.nextOfKinForm ||
        Object.values(draft.nextOfKinForm).every(
          (val) => val === '' || val === null || val === undefined
        )
      ) {
        setNextOfKin({
          crewId: crewId!,
          civilStatus: null,
          fullName: '',
          relationship: '',
          address: '',
          pinCode: '',
          phoneStdCode: '',
          phoneNumber: '',
        });
        setNextOfKinSnapshot(JSON.stringify({}));
      }
    }
  };

  const checkExistingBankingDetails = async () => {
    try {
      const resp = await getBankingDetails(crewId!);
      if (resp && typeof resp.id === 'number') {
        setExistingBankingDetails(resp);
        const normalized = {
          crewId: resp.crewId ?? crewId,
          nameOfBeneficiary: resp.nameOfBeneficiary || '',
          accountNumber: resp.accountNumber || '',
          bankName: resp.bankName || '',
          branchName: resp.branchName || '',
          branchCode: resp.branchCode || '',
          ifscRtgsType: resp.ifscRtgsType || 'IFSC',
          ifscRtgsCode: resp.ifscRtgsCode || '',
          swiftIandi: resp.swiftIandi || '',
          bankAddress: resp.bankAddress || '',
          accountCurrency: resp.accountCurrency || '',
          otherCurrency: resp.otherCurrency || '',
          salaryCurrency: resp.salaryCurrency || '',
          salaryOtherCurrency: resp.salaryOtherCurrency || '',
          remarks: resp.remarks || '',
          basicWages: resp.basicWages ?? resp.totalBasic ?? null,
          fixedOvertime109Hrs: resp.fixedOvertime109Hrs ?? resp.overtimePay ?? null,
          leaveWages9DaysPerMonth: resp.leaveWages9DaysPerMonth ?? resp.leavePay ?? null,
          subSmb: resp.subSmb ?? null,
          tradeAllowance: resp.tradeAllowance ?? null,
          otherAllowance: resp.otherAllowance ?? resp.incentive ?? null,
          ownersLoyaltyBonus: resp.ownersLoyaltyBonus ?? null,
          rejoiningBonus: resp.rejoiningBonus ?? null,
          overtimeRate: resp.overtimeRate ?? null,
          unionSocialDues: resp.unionSocialDues || 'As per CBA',
          cashAdvanceFromOffice: resp.cashAdvanceFromOffice ?? null,
          deductionBond: resp.deductionBond ?? null,
          deductionInternetCard: resp.deductionInternetCard ?? null,
          otherDeductions: resp.otherDeductions ?? null,
          deductionsTotal: resp.deductionsTotal ?? null,
          salary: resp.salary ?? null,
        };
        setBankingDetails(normalized);
        setBankingDetailsSnapshot(JSON.stringify(normalized));
      } else {
        setExistingBankingDetails(null);
      }
    } catch (error) {
      console.error('No existing banking details found:', error);
      setExistingBankingDetails(null);
    }
  };

  const checkExistingCourseCertificates = async () => {
    if (!crewId) return;
    try {
      const resp = await getCourseCertificates(crewId);
      if (resp && resp.length > 0 && resp.some((item) => item.id)) {
        setExistingCourseCertificates(resp);
        const updatedCertificates = buildCourseCertificateState(resp);
        setCourseCertificates(updatedCertificates);
        setCourseCertificatesSnapshot(JSON.stringify(updatedCertificates));
      } else {
        setExistingCourseCertificates([]);
        const raw = localStorage.getItem(DRAFT_KEY);
        const draft = raw ? JSON.parse(raw) : null;
        if (
          !draft?.coursesForm ||
          draft.coursesForm.every((item: any) =>
            Object.values(item).every((val) => val === '' || val === null || val === undefined)
          )
        ) {
          const cleanState = buildCourseCertificateState();
          setCourseCertificates(cleanState);
          setCourseCertificatesSnapshot(JSON.stringify(cleanState));
        } else {
          const mergedDraftState = buildCourseCertificateState(draft.coursesForm);
          setCourseCertificates(mergedDraftState);
          setCourseCertificatesSnapshot(JSON.stringify(mergedDraftState));
        }
      }
    } catch (error) {
      console.error('No existing course certificates found:', error);
      setExistingCourseCertificates([]);
      const raw = localStorage.getItem(DRAFT_KEY);
      const draft = raw ? JSON.parse(raw) : null;
      if (
        !draft?.coursesForm ||
        draft.coursesForm.every((item: any) =>
          Object.values(item).every((val) => val === '' || val === null || val === undefined)
        )
      ) {
        const cleanState = buildCourseCertificateState();
        setCourseCertificates(cleanState);
        setCourseCertificatesSnapshot(JSON.stringify(cleanState));
      } else {
        const mergedDraftState = buildCourseCertificateState(draft.coursesForm);
        setCourseCertificates(mergedDraftState);
        setCourseCertificatesSnapshot(JSON.stringify(mergedDraftState));
      }
    }
  };

  const checkExistingSeaServices = async () => {
    try {
      const resp = await getSeaServices(crewId!);
      if (resp && resp.length > 0 && resp.some((item) => item.id)) {
        setExistingSeaServices(resp);
        const updatedServices = resp
          .sort((a, b) => a.serialNo - b.serialNo)
          .map((item, index) => ({
            id: item.id,
            serialNo: index + 1,
            companyName: item.companyName || '',
            vesselName: item.vesselName || '',
            typeOfVesselFlag: item.typeOfVesselFlag || '',
            grtdrt: item.grtdrt || '',
            engineType: item.engineType || '',
            kwtBhp: item.kwtBhp || '',
            rank: item.rank || '',
            fromDate: item.fromDate || '',
            toDate: item.toDate || '',
            totalMonthsDays: item.totalMonthsDays || '',
            reasonForSignOff: item.reasonForSignOff || '',
          }));
        setSeaServices(updatedServices);
        setSeaServiceSnapshot(JSON.stringify(updatedServices));
      } else {
        setExistingSeaServices([]);
        const raw = localStorage.getItem(DRAFT_KEY);
        const draft = raw ? JSON.parse(raw) : null;
        if (
          !draft?.seaServiceForm ||
          draft.seaServiceForm.every((item: any) =>
            Object.values(item).every((val) => val === '' || val === null || val === undefined)
          )
        ) {
          setSeaServices([
            {
              serialNo: 1,
              companyName: '',
              vesselName: '',
              typeOfVesselFlag: '',
              grtdrt: '',
              engineType: '',
              kwtBhp: '',
              rank: '',
              fromDate: '',
              toDate: '',
              totalMonthsDays: '',
              reasonForSignOff: '',
            },
          ]);
          setSeaServiceSnapshot(JSON.stringify([]));
        } else {
          setSeaServices(draft.seaServiceForm);
          setSeaServiceSnapshot(JSON.stringify(draft.seaServiceForm));
        }
      }
    } catch (error) {
      console.error('No existing sea services found:', error);
      setExistingSeaServices([]);
      const raw = localStorage.getItem(DRAFT_KEY);
      const draft = raw ? JSON.parse(raw) : null;
      if (
        !draft?.seaServiceForm ||
        draft.seaServiceForm.every((item: any) =>
          Object.values(item).every((val) => val === '' || val === null || val === undefined)
        )
      ) {
        setSeaServices([
          {
            serialNo: 1,
            companyName: '',
            vesselName: '',
            typeOfVesselFlag: '',
            grtdrt: '',
            engineType: '',
            kwtBhp: '',
            rank: '',
            fromDate: '',
            toDate: '',
            totalMonthsDays: '',
            reasonForSignOff: '',
          },
        ]);
        setSeaServiceSnapshot(JSON.stringify([]));
      } else {
        setSeaServices(draft.seaServiceForm);
        setSeaServiceSnapshot(JSON.stringify(draft.seaServiceForm));
      }
    }
  };

  const checkExistingFlagDocuments = async () => {
    try {
      const resp = await getFlagDocuments(crewId!)
      setExistingFlagDocuments(resp)
    } catch (error) {
      console.error('No existing flag documents found:', error)
      setExistingFlagDocuments([])
    }
  }

  const validateFile = (file: File | null) => {
    const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf']
    const maxSize = 9 * 1024 * 1024 // 9 MB

    if (!file) return { isValid: false, message: 'No file selected.' }
    if (!validTypes.includes(file.type)) {
      return {
        isValid: false,
        message: 'Invalid file type. Only JPEG, PNG, JPG, and PDF are allowed.',
      }
    }
    if (file.size > maxSize) {
      return { isValid: false, message: 'File is too large. Maximum size is 9MB.' }
    }
    return { isValid: true, message: '' }
  }

  const handleCertificationChange = (index: number, key: 'documentName' | 'file', value: any) => {
    const updated = [...certifications]
    updated[index][key] = value
    setCertifications(updated)

    if (key === 'file') {
      const validation = validateFile(value)
      if (!validation.isValid) {
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          [`certification_${index}`]: validation.message,
        }))
      } else {
        setFieldErrors((prevErrors) => {
          const newErrors = { ...prevErrors }
          delete newErrors[`certification_${index}`]
          return newErrors
        })
      }
    }
  }

  const handleAddCertification = () => {
    setCertifications([...certifications, { documentName: '', file: null }])
  }

  const handleDocumentChange = (index: number, key: 'documentName' | 'file', value: any) => {
    const updated = [...documents]
    updated[index][key] = value
    setDocuments(updated)

    if (key === 'file') {
      const validation = validateFile(value)
      if (!validation.isValid) {
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          [`document_${index}`]: validation.message,
        }))
      } else {
        setFieldErrors((prevErrors) => {
          const newErrors = { ...prevErrors }
          delete newErrors[`document_${index}`]
          return newErrors
        })
      }
    }
  }

  const handleAddDocument = () => {
    setDocuments([...documents, { documentName: '', file: null }])
  }

  const handleRemoveDocument = (index: number) => {
    const updated = documents.filter((_, i) => i !== index)
    setDocuments(updated)
  }

  const handleRemoveCertification = (index: number) => {
    const updated = certifications.filter((_, i) => i !== index)
    setCertifications(updated)
  }

  const handleAcademicBackgroundChange = (
    index: number,
    field: keyof AcademicQualificationRequest,
    value: string
  ) => {
    const updated = [...academicBackgrounds]
    updated[index][field] = value
    setAcademicBackgrounds(updated)
  }

  const handleAddAcademicBackground = () => {
    setAcademicBackgrounds([
      ...academicBackgrounds,
      {
        qualification: '',
        institutionName: '',
        boardOrUniversity: '',
        dateOfPassing: '',
        gradeOrPercentage: '',
        englishProficiency: '',
      },
    ])
  }

  const handleRemoveAcademicBackground = (index: number) => {
    if (academicBackgrounds.length > 1) {
      const updated = academicBackgrounds.filter((_, i) => i !== index)
      setAcademicBackgrounds(updated)
    }
  }

  const handleCourseCertificateChange = (
    index: number,
    field: keyof CourseCertificate,
    value: string
  ) => {
    setCourseCertificates((prev) => {
      if (!prev[index]) {
        return prev;
      }

      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleAddCourseCertificateRow = (category: string) => {
    setCourseCertificates((prev) => [
      ...prev,
      normalizeCourseCertificate(
        {
          certificateName: '',
          category,
          certificateNumber: '',
          dateOfIssue: '',
          dateOfExpiry: '',
          issuedBy: '',
        },
        category
      ),
    ]);
  }

  const handleRemoveCourseCertificateRow = (index: number) => {
    setCourseCertificates((prev) => prev.filter((_, rowIndex) => rowIndex !== index));
  }

  const calculateSeaServiceDuration = (fromDate?: string | null, toDate?: string | null): string => {
    if (!fromDate || !toDate) {
      return '';
    }

    const start = new Date(`${fromDate}T00:00:00`);
    const end = new Date(`${toDate}T00:00:00`);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) {
      return '';
    }

    // Include both start and end day in sea service duration.
    const inclusiveEnd = new Date(end);
    inclusiveEnd.setDate(inclusiveEnd.getDate() + 1);

    let months =
      (inclusiveEnd.getFullYear() - start.getFullYear()) * 12 +
      (inclusiveEnd.getMonth() - start.getMonth());

    const anchor = new Date(start);
    anchor.setMonth(anchor.getMonth() + months);

    if (anchor > inclusiveEnd) {
      months -= 1;
      anchor.setMonth(anchor.getMonth() - 1);
    }

    const dayDiffMs = inclusiveEnd.getTime() - anchor.getTime();
    const days = Math.floor(dayDiffMs / (1000 * 60 * 60 * 24));

    return `${months} month(s) ${days} day(s)`;
  };

  const handleSeaServiceChange = (index: number, field: keyof SeaServiceRequest, value: string) => {
    setSeaServices((prev) =>
      prev.map((service, i) => {
        if (i !== index) {
          return service;
        }

        const updated = { ...service, [field]: value };

        if (field === 'fromDate' || field === 'toDate') {
          updated.totalMonthsDays = calculateSeaServiceDuration(updated.fromDate, updated.toDate);
        }

        return updated;
      })
    );
  };
  const handleAddSeaService = () => {
    const newSerialNo = seaServices.length + 1;
    setSeaServices([
      ...seaServices,
      {
        serialNo: newSerialNo,
        companyName: '',
        vesselName: '',
        typeOfVesselFlag: '',
        grtdrt: '',
        engineType: '',
        kwtBhp: '',
        rank: '',
        fromDate: '',
        toDate: '',
        totalMonthsDays: '',
        reasonForSignOff: '',
      },
    ]);
  };

  const handleRemoveSeaService = (index: number) => {
    setSeaServices((prev) => {
      // If it’s the only row, “delete” means reset it to empty
      if (prev.length === 1) {
        return [emptySeaServiceRow(1)];
      }

      const updated = prev
        .filter((_, i) => i !== index)
        .map((service, i) => ({
          ...service,
          serialNo: i + 1,
        }));

      return updated;
    });
  };

  const [rows, setRows] = useState([1]) // Start with 1 row

  const addRow = () => {
    setRows([...rows, rows.length + 1])
  }

  const removeRow = (index: number) => {
    if (rows.length > 1) {
      setRows(rows.filter((_, i) => i !== index))
    }
  }

  const fetchCompaniesByAdmin = async (adminId: number) => {
    try {
      const companyList = await getCompanyList()
      console.log(companyList)
      const filteredCompanies = companyList.filter(
        (c) => c.cga?.id === adminId && c.active === true
      )
      setCompaniesByAdmin(filteredCompanies)
    } catch (error) {
      console.error('Failed to fetch companies:', error)
    }
  }

  const fetchVessels = async () => {
    try {
      try {
        const accessible = await fetchAccessibleVesselsForCurrentUser()
        if (accessible && accessible.length > 0) {
          const list = normalizeAccessibleVessels(accessible).filter((v) => v.active !== false)
          if (list.length > 0) {
            setVessels(list)
            return
          }
        }
      } catch (err) {
        // fallback to getVesselList below
      }

      const vesselList = await getVesselList()

      const vesselsForCompany = vesselList.filter((vessel) => {
        const isActive = vessel.active

        if (roleId === 1 || isSuperadminOperator) {
          // Superadmin & Superadmin-operator => all active vessels
          return isActive
        } else if (roleId === 5 || isGroupOperator) {
          // CGA & group-scoped Operator => only vessels in their CGA
          const groupId = roleId === 5 ? roleEntityId : cgaId
          return isActive && (!groupId || vessel.companyGroupAdmin?.id === groupId)
        } else if (roleId === 2 || isCompanyOperator) {
          // Company Admin & company-scoped Operator
          const companyId = roleId === 2 ? roleEntityId : caId
          return isActive && (!companyId || vessel.companyAdmin?.id === companyId)
        }

        return isActive
      })

      setVessels(vesselsForCompany)
    } catch (error) {
      console.error('Failed to fetch vessel list:', error)
    }
  }


  const validateDocumentFields = () => {
    const errors: Record<string, string> = {}

    // Mandatory National CDC validation
    if (!documentForm.cdcNumber?.trim()) {
      errors.cdcNumber = 'CDC Number is required'
    }
    if (!documentForm.cdcIssueDate?.trim()) {
      errors.cdcIssueDate = 'Date of Issue is required'
    }
    if (!documentForm.cdcPlaceOfIssue?.trim()) {
      errors.cdcPlaceOfIssue = 'Place of Issue is required'
    }
    if (!documentForm.cdcExpiryDate?.trim()) {
      errors.cdcExpiryDate = 'Date of Expiry is required'
    }

    setFieldErrors(errors)
    return Object.keys(errors).length === 0
  }


  const validateAcademicFields = () => {
    // const errors: Record<string, string> = {}
    // academicBackgrounds.forEach((academic, index) => {
    //   if (!academic.qualification?.trim()) {
    //     errors[`academic_qualification_${index}`] = 'Qualification is required'
    //   }
    //   if (!academic.institutionName?.trim()) {
    //     errors[`academic_institution_${index}`] = 'Institution Name is required'
    //   }
    //   if (!academic.boardOrUniversity?.trim()) {
    //     errors[`academic_boardOrUniversity_${index}`] = 'Board/University is required'
    //   }
    //   if (!academic.dateOfPassing) {
    //     errors[`academic_dateOfPassing_${index}`] = 'Date of Passing is required'
    //   }
    //   if (!academic.gradeOrPercentage?.trim()) {
    //     errors[`academic_gradeOrPercentage_${index}`] = 'Grade/Percentage is required'
    //   } else if (!/^\d{1,3}%$/.test(academic.gradeOrPercentage)) {
    //     errors[`academic_gradeOrPercentage_${index}`] =
    //       'Grade/Percentage must be in format e.g., 75%'
    //   }
    // })
    // setFieldErrors(errors)
    // return Object.keys(errors).length === 0
    return true // Temporarily disable validation
  }

  const validateWatchkeepingFields = () => {
    // const errors: Record<string, string> = {}
    // watchkeepingCertificates.forEach((certificate, index) => {
    //   if (!certificate.certificateNo?.trim()) {
    //     errors[`watchkeeping_certificateNo_${index}`] = 'Certificate Number is required'
    //   } else if (!/^[A-Z0-9-]{6,12}$/.test(certificate.certificateNo)) {
    //     errors[`watchkeeping_certificateNo_${index}`] =
    //       'Invalid Certificate Number format (e.g., WKC-123456)'
    //   }
    //   if (!certificate.dateOfIssue) {
    //     errors[`watchkeeping_dateOfIssue_${index}`] = 'Date of Issue is required'
    //   }
    //   if (!certificate.placeOfIssue?.trim()) {
    //     errors[`watchkeeping_placeOfIssue_${index}`] = 'Place of Issue is required'
    //   }
    //   if (!certificate.validUntil) {
    //     errors[`watchkeeping_validUntil_${index}`] = 'Valid Until is required'
    //   }
    // })
    // setFieldErrors(errors)
    // return Object.keys(errors).length === 0
    return true // Temporarily disable validation
  }

  const validateNextOfKinFields = () => {
    const errors: Record<string, string> = {};
    if (!nextOfKin.civilStatus) {
      errors.civilStatus = 'Civil Status is required';
    }
    if (!nextOfKin.fullName?.trim()) {
      errors.fullName = 'Full Name is required';
    }
    if (!nextOfKin.relationship?.trim()) {
      errors.relationship = 'Relationship is required';
    }
    // if (!nextOfKin.address?.trim()) {
    //   errors.address = 'Address is required';
    // }
    if ((nextOfKin.pinCode?.trim()) && (!/^\d{6}$/.test(nextOfKin.pinCode))) {
      errors.pinCode = 'Pin Code must be a 6-digit number';
    }
    if ((nextOfKin.phoneStdCode?.trim()) && (!/^\d{3,5}$/.test(nextOfKin.phoneStdCode))) {
      errors.phoneStdCode = 'STD Code must be a 3-5 digit number';
    }
    if ((nextOfKin.phoneNumber?.trim()) && (!/^\d{8,10}$/.test(nextOfKin.phoneNumber))) {
      errors.phoneNumber = 'Phone Number must be 8-10 digits';
    }
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
    // return true; // Temporarily disable validation
  };

  const validateCourseCertificateFields = () => {
    // const errors: Record<string, string> = {};
    // courseCertificates.forEach((certificate, index) => {
    //   if (certificate.certificateNumber?.trim()) {
    //     if (!/^[A-Z0-9-]{6,12}$/.test(certificate.certificateNumber)) {
    //       errors[`course_certificateNumber_${index}`] =
    //         'Invalid Certificate Number format (e.g., AFF-123456)';
    //     }
    //     if (!certificate.dateOfIssue) {
    //       errors[`course_dateOfIssue_${index}`] = 'Date of Issue is required';
    //     }
    //     if (!certificate.dateOfExpiry) {
    //       errors[`course_dateOfExpiry_${index}`] = 'Date of Expiry is required';
    //     }
    //     if (!certificate.issuedBy?.trim()) {
    //       errors[`course_issuedBy_${index}`] = 'Issued By is required';
    //     }
    //   }
    // });
    // setFieldErrors(errors);
    // return Object.keys(errors).length === 0;
    return true; // Temporarily disable validation
  };

  const validateSeaServiceFields = () => {
    // const errors: Record<string, string> = {};
    // seaServices.forEach((service, index) => {
    //   if (service.companyName?.trim()) {
    //     if (!service.vesselName?.trim()) {
    //       errors[`sea_vesselName_${index}`] = 'Vessel Name is required';
    //     }
    //     if (!service.typeOfVesselFlag?.trim()) {
    //       errors[`sea_typeOfVesselFlag_${index}`] = 'Type of Vessel/Flag is required';
    //     }
    //     if (!service.grtdrt?.trim()) {
    //       errors[`sea_grtdrt_${index}`] = 'GRT/DWT is required';
    //     }
    //     if (!service.engineType?.trim()) {
    //       errors[`sea_engineType_${index}`] = 'Engine Type is required';
    //     }
    //     if (!service.kwtBhp?.trim()) {
    //       errors[`sea_kwtBhp_${index}`] = 'KWT/ME BHP is required';
    //     }
    //     if (!service.rank?.trim()) {
    //       errors[`sea_rank_${index}`] = 'Rank is required';
    //     }
    //     if (!service.fromDate) {
    //       errors[`sea_fromDate_${index}`] = 'From Date is required';
    //     }
    //     if (!service.toDate) {
    //       errors[`sea_toDate_${index}`] = 'To Date is required';
    //     }
    //     if (!service.totalMonthsDays?.trim()) {
    //       errors[`sea_totalMonthsDays_${index}`] = 'Total Months/Days is required';
    //     }
    //     if (!service.reasonForSignOff?.trim()) {
    //       errors[`sea_reasonForSignOff_${index}`] = 'Reason for S/OFF is required';
    //     }
    //   }
    // });
    // setFieldErrors(errors);
    // return Object.keys(errors).length === 0;
    return true; // Temporarily disable validation
  };

  const validateAdditionalDetailsFields = () => {
    const errors: Record<string, string> = {};

    // // Validate pump experience months (optional, but must be non-negative if provided)
    // if (additionalDetails.pumpExperienceFramoMonths && additionalDetails.pumpExperienceFramoMonths < 0) {
    //   errors.pumpExperienceFramoMonths = 'FRAMO experience months cannot be negative';
    // }
    // if (additionalDetails.pumpExperienceCopMonths && additionalDetails.pumpExperienceCopMonths < 0) {
    //   errors.pumpExperienceCopMonths = 'COP experience months cannot be negative';
    // }

    // // Validate conditional fields only if their corresponding boolean is true
    // if (additionalDetails.drydockingExperience && !additionalDetails.drydockingRank?.trim()) {
    //   errors.drydockingRank = 'Drydocking rank is required when experience is selected';
    // }
    // if (additionalDetails.newConstructionExperience && !additionalDetails.newConstructionRank?.trim()) {
    //   errors.newConstructionRank = 'New construction rank is required when experience is selected';
    // }
    // if (additionalDetails.incidentInvolvement && !additionalDetails.incidentDetails?.trim()) {
    //   errors.incidentDetails = 'Incident details are required when involvement is selected';
    // }
    // if (additionalDetails.courtOfEnquiryInvolvement && !additionalDetails.courtOfEnquiryDetails?.trim()) {
    //   errors.courtOfEnquiryDetails = 'Court of enquiry details are required when involvement is selected';
    // }
    // if (additionalDetails.criminalCaseInvolved && !additionalDetails.criminalCaseDetails?.trim()) {
    //   errors.criminalCaseDetails = 'Criminal case details are required when involvement is selected';
    // }
    // if (additionalDetails.certificateSuspendedRevoked && !additionalDetails.certificateSuspendedRevokedDetails?.trim()) {
    //   errors.certificateSuspendedRevokedDetails = 'Certificate suspension details are required when selected';
    // }
    // if (additionalDetails.hasMedicalConditions && !additionalDetails.medicalConditionsDetails?.trim()) {
    //   errors.medicalConditionsDetails = 'Medical condition details are required when selected';
    // }
    // if (additionalDetails.habitualUseDrugsAlcohol && !additionalDetails.habitualUseDetails?.trim()) {
    //   errors.habitualUseDetails = 'Habitual use details are required when selected';
    // }
    // if (additionalDetails.workedWithMultinational && !additionalDetails.multinationalNationalities?.trim()) {
    //   errors.multinationalNationalities = 'Nationalities are required when multinational workforce is selected';
    // }

    // // Validate referral source and details (optional, but details required if source is selected)
    // if (additionalDetails.referralSource && !additionalDetails.referralDetails?.trim()) {
    //   errors.referralDetails = 'Referral details are required when source is selected';
    // }

    // // Validate references only if hasReferenceData is true
    // if (additionalDetails.hasReferenceData) {
    //   references.forEach((ref, index) => {
    //     if (!ref.companyName?.trim()) {
    //       errors[`reference_companyName_${index}`] = 'Company name is required';
    //     }
    //     if (!ref.pic?.trim()) {
    //       errors[`reference_pic_${index}`] = 'Person in charge is required';
    //     }
    //     if (!ref.designation?.trim()) {
    //       errors[`reference_designation_${index}`] = 'Designation is required';
    //     }
    //     if (!ref.phoneNo?.trim()) {
    //       errors[`reference_phoneNo_${index}`] = 'Phone number is required';
    //     } else if (!/^\+?[0-9\s\-()]{7,20}$/.test(ref.phoneNo)) {
    //       errors[`reference_phoneNo_${index}`] = 'Invalid phone number format';
    //     }
    //   });
    // }

    // --- Declarations: require all 6 to be confirmed ---
    if (additionalDetails.declarationMedicalExam !== true) {
      errors.declarationMedicalExam = 'Please confirm the medical examination declaration';
    }
    if (additionalDetails.declarationMedicalDecision !== true) {
      errors.declarationMedicalDecision = 'Please confirm the medical decision declaration';
    }
    if (additionalDetails.declarationNoCriminal !== true) {
      errors.declarationNoCriminal = 'Please confirm the no criminal investigations declaration';
    }
    if (additionalDetails.declarationDocumentsValid !== true) {
      errors.declarationDocumentsValid = 'Please confirm the valid travel documents declaration';
    }
    if (additionalDetails.declarationNotEmployed !== true) {
      errors.declarationNotEmployed = 'Please confirm the present employment declaration';
    }

    // 6th declaration (No Agents) must be checked, and its date is required
    if (additionalDetails.declarationNoAgents !== true) {
      errors.declarationNoAgents = 'Please confirm awareness about no agents';
    }
    if (additionalDetails.declarationNoAgents === true && !additionalDetails.availabilityDate) {
      errors.availabilityDate = 'Please provide the availability date';
    }


    // Require only applicant name and date
    if (!additionalDetails.applicantName?.trim()) {
      errors.applicantName = 'Applicant name is required';
    }
    if (!additionalDetails.applicantDate) {
      errors.applicantDate = 'Applicant date is required';
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleDocumentFormChange = (field: keyof CrewDocumentForm, value: any) => {
    setDocumentForm((prev) => ({ ...prev, [field]: value }))
  }

  const handleWatchkeepingCertificateChange = (
    index: number,
    field: keyof WatchkeepingCertificateRequest,
    value: string
  ) => {
    const updated = [...watchkeepingCertificates]
    updated[index][field] = value
    setWatchkeepingCertificates(updated)
  }

  const handleNextOfKinChange = (field: keyof NextOfKinRequest, value: any) => {
    setNextOfKin((prev) => ({ ...prev, [field]: value }));
  };

  const handleDocumentSubmit = async () => {
    clearTopError();
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.')
      toast.warn('Please fill and save Personal Data first.')
      return
    }
    if (!validateDocumentFields()) {
      setError('Please fill out all mandatory National CDC fields.')
      toast.warn('Please fill out all mandatory National CDC fields.')
      return
    }
    setIsSubmittingTab(true)
    try {
      if (existingDocument?.id) {
        await updateCrewDocument(crewId, existingDocument.id, documentForm)
        toast.success('Documents updated')
      } else {
        const created = await createCrewDocument(crewId, documentForm)
        setExistingDocument(created)
        toast.success('Documents saved')
      }
      setSavedTabs((s) => ({ ...s, documents: true }))
      setDocumentSnapshot(JSON.stringify(documentForm))
      // before navigating forward, make sure any previous error is cleared
      clearTopError();
      setActiveTab(nextTab('documents'))
      await checkExistingDocument();
    } catch (err) {
      console.error('Failed to save document:', err)
      const msg = showErrorToast(err, 'Failed to save document.')
      setError(msg)
    } finally {
      setIsSubmittingTab(false)
    }
  }

  const handleAcademicSubmit = async () => {
    clearTopError();
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.')
      toast.warn('Please fill and save Personal Data first.')
      return
    }
    setIsSubmittingTab(true)
    try {
      const existingIds = existingAcademicDetails
        .map((item) => item.id)
        .filter((id): id is number => id !== undefined)
      const updatedBackgrounds = await Promise.all(
        academicBackgrounds.map(async (academic, index) => {
          const academicData: AcademicQualificationRequest = {
            qualification: academic.qualification,
            institutionName: academic.institutionName,
            boardOrUniversity: academic.boardOrUniversity,
            dateOfPassing: academic.dateOfPassing,
            gradeOrPercentage: academic.gradeOrPercentage,
            englishProficiency: academic.englishProficiency,
          }
          const academicResponse = existingAcademicDetails[index]
          if (academicResponse?.id && existingIds.includes(academicResponse.id)) {
            return await updateAcademicDetails(crewId, academicResponse.id, academicData)
          } else {
            return await createAcademicDetails(crewId, academicData)
          }
        })
      )
      setExistingAcademicDetails(updatedBackgrounds)
      setAcademicBackgrounds(
        updatedBackgrounds.map((item) => ({
          qualification: item.qualification || '',
          institutionName: item.institutionName || '',
          boardOrUniversity: item.boardOrUniversity || '',
          dateOfPassing: item.dateOfPassing || '',
          gradeOrPercentage: item.gradeOrPercentage || '',
          englishProficiency: item.englishProficiency || '',
        }))
      )
      setSavedTabs((s) => ({ ...s, academic: true }))
      setAcademicSnapshot(JSON.stringify(updatedBackgrounds))
      toast.success(
        existingAcademicDetails.length > 0 ? 'Academic Details updated' : 'Academic Details saved'
      )
      // before navigating forward, make sure any previous error is cleared
      clearTopError();
      setActiveTab(nextTab('academic'))
    } catch (err) {
      console.error('Failed to save academic details:', err)
      const msg = showErrorToast(err, 'Failed to save academic details.')
      setError(msg)
    } finally {
      setIsSubmittingTab(false)
    }
  }

  const handleWatchkeepingSubmit = async () => {
    clearTopError();
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.')
      toast.warn('Please fill and save Personal Data first.')
      return
    }
    setIsSubmittingTab(true)
    try {
      // Always use latest data so row-level uploads don't cause duplicates
      const fresh = await getWatchkeepingCertificates(crewId)
      setExistingWatchkeepingCertificates(fresh)

      const existingIds = fresh
        .map((item) => item.id)
        .filter((id): id is number => id !== undefined)

      const updatedCertificates = await Promise.all(
        watchkeepingCertificates.map(async (certificate) => {
          const certificateData: WatchkeepingCertificateRequest = {
            certificateDetails: certificate.certificateDetails,
            certificateNo: certificate.certificateNo || null,
            dateOfIssue: certificate.dateOfIssue || null,
            placeOfIssue: certificate.placeOfIssue || null,
            validUntil: certificate.validUntil || null,
          }
          const existingCert = fresh.find(
            (cert) => cert.certificateDetails === certificate.certificateDetails
          )
          if (existingCert?.id && existingIds.includes(existingCert.id)) {
            return await updateWatchkeepingCertificate(crewId, existingCert.id, certificateData)
          } else if (certificate.certificateNo?.trim() || certificate.dateOfIssue || certificate.placeOfIssue?.trim() || certificate.validUntil) {
            return await createWatchkeepingCertificate(crewId, certificateData)
          }
          return null
        })
      )
      const validCertificates = updatedCertificates.filter(
        (cert): cert is WatchkeepingCertificateResponse => cert !== null
      )
      setExistingWatchkeepingCertificates(validCertificates)
      setWatchkeepingCertificates(
        certificateDetails.map((detail) => {
          const existingCert = validCertificates.find((cert) => cert.certificateDetails === detail)
          return {
            certificateDetails: detail,
            certificateNo: existingCert?.certificateNo || '',
            dateOfIssue: existingCert?.dateOfIssue || '',
            placeOfIssue: existingCert?.placeOfIssue || '',
            validUntil: existingCert?.validUntil || '',
          }
        })
      )
      setSavedTabs((s) => ({ ...s, watchkeeping: true }))
      setWatchkeepingSnapshot(JSON.stringify(updatedCertificates))
      toast.success(
        existingWatchkeepingCertificates.length > 0
          ? 'Watchkeeping Certificates updated'
          : 'Watchkeeping Certificates saved'
      )
      clearTopError()
      setActiveTab(nextTab('watchkeeping'))
    } catch (err) {
      console.error('Failed to save watchkeeping certificates:', err)
      const msg = showErrorToast(err, 'Failed to save watchkeeping certificates.')
      setError(msg)
    } finally {
      setIsSubmittingTab(false)
    }
  }

  const handleNextOfKinSubmit = async () => {
    clearTopError();
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.');
      toast.warn('Please fill and save Personal Data first.');
      return;
    }
    if (!validateNextOfKinFields()) {
      toast.warn('Please fill out the form correctly.');
      return;
    }
    setIsSubmittingTab(true)
    try {
      const nextOfKinData: NextOfKinRequest = {
        crewId: crewId!,
        civilStatus: nextOfKin.civilStatus,
        fullName: nextOfKin.fullName || null,
        relationship: nextOfKin.relationship || null,
        address: nextOfKin.address || null,
        pinCode: nextOfKin.pinCode || null,
        phoneStdCode: nextOfKin.phoneStdCode || null,
        phoneNumber: nextOfKin.phoneNumber || null,
      };
      if (existingNextOfKin?.id) {
        await updateNextOfKin(crewId, existingNextOfKin.id, nextOfKinData);
        toast.success('Next of Kin updated');
      } else {
        const created = await createNextOfKin(crewId, nextOfKinData);
        setExistingNextOfKin(created);
        toast.success('Next of Kin saved');
      }
      setSavedTabs((s) => ({ ...s, kin: true }));
      setNextOfKinSnapshot(JSON.stringify(nextOfKinData));
      // before navigating forward, make sure any previous error is cleared
      clearTopError();
      setActiveTab(nextTab('kin'));
    } catch (err) {
      console.error('Failed to save next of kin:', err);
      const msg = showErrorToast(err, 'Failed to save next of kin.');
      setError(msg);
    } finally {
      setIsSubmittingTab(false)
    }
  };

  const handleCourseCertificatesSubmit = async () => {
    clearTopError();
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.');
      toast.warn('Please fill and save Personal Data first.');
      return;
    }
    setIsSubmittingTab(true)
    try {
      // Refresh from backend to avoid duplicates after row-level uploads
      const fresh = await getCourseCertificates(crewId)
      setExistingCourseCertificates(fresh)

      const existingIds = fresh
        .map((item) => item.id)
        .filter((id): id is number => id !== undefined)

      await Promise.all(
        courseCertificates.map(async (certificate) => {
          const certificateName = (certificate.certificateName || '').trim()
          const hasAnyDetails =
            !!certificate.certificateNumber?.trim() ||
            !!certificate.dateOfIssue?.trim() ||
            !!certificate.dateOfExpiry?.trim() ||
            !!certificate.issuedBy?.trim()

          if (!certificateName) {
            return null
          }

          const certificateData: CourseCertificate = {
            certificateName,
            category: certificate.category || getCategoryForCourse(certificateName),
            certificateNumber: certificate.certificateNumber || null,
            dateOfIssue: certificate.dateOfIssue || null,
            dateOfExpiry: certificate.dateOfExpiry || null,
            issuedBy: certificate.issuedBy || null,
          }
          const existingCert = fresh.find(
            (cert) => cert.id === certificate.id || (
              cert.certificateName === certificateName &&
              (cert.category || '') === (certificateData.category || '')
            )
          )

          if (!existingCert && !hasAnyDetails) return null
          if (existingCert?.id && existingIds.includes(existingCert.id)) {
            return await updateCourseCertificate(crewId, existingCert.id, certificateData)
          } else {
            return await createCourseCertificate(crewId, certificateData)
          }
        })
      )

      const refreshedCertificates = await getCourseCertificates(crewId)
      setExistingCourseCertificates(refreshedCertificates)

      const normalized = buildCourseCertificateState(refreshedCertificates)
      setCourseCertificates(normalized)
      setSavedTabs((s) => ({ ...s, courses: true }))
      setCourseCertificatesSnapshot(JSON.stringify(normalized))
      toast.success(
        refreshedCertificates.length > 0
          ? 'Course Certificates updated'
          : 'Course Certificates saved'
      )
      clearTopError()
      setActiveTab(nextTab('courses'))
    } catch (err) {
      console.error('Failed to save course certificates:', err)
      const msg = showErrorToast(err, 'Failed to save course certificates.')
      setError(msg)
    } finally {
      setIsSubmittingTab(false)
    }
  };

  const handleSeaServiceSubmit = async () => {
    clearTopError();
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.');
      toast.warn('Please fill and save Personal Data first.');
      return;
    }

    setIsSubmittingTab(true)
    try {
      // ✅ Always refresh existing from backend before diffing (prevents mismatch)
      const freshExisting = await getSeaServices(crewId);
      setExistingSeaServices(freshExisting);

      const currentIds = seaServices.map(s => s.id).filter((x): x is number => typeof x === 'number');
      const deletedIds = freshExisting
        .map(s => s.id)
        .filter(id => !currentIds.includes(id));

      // ✅ delete removed rows in backend
      await Promise.all(deletedIds.map(id => deleteSeaService(crewId, id)));

      // ✅ upsert remaining rows
      const upserts = await Promise.all(
        seaServices.map(async (service, index) => {
          const seaServiceData: SeaServiceRequest = {
            serialNo: index + 1,
            companyName: service.companyName?.trim() ? service.companyName : null,
            vesselName: service.vesselName?.trim() ? service.vesselName : null,
            typeOfVesselFlag: service.typeOfVesselFlag?.trim() ? service.typeOfVesselFlag : null,
            grtdrt: service.grtdrt?.trim() ? service.grtdrt : null,
            engineType: service.engineType?.trim() ? service.engineType : null,
            kwtBhp: service.kwtBhp?.trim() ? service.kwtBhp : null,
            rank: service.rank?.trim() ? service.rank : null,
            fromDate: service.fromDate || null,
            toDate: service.toDate || null,
            totalMonthsDays: service.totalMonthsDays?.trim() ? service.totalMonthsDays : null,
            reasonForSignOff: service.reasonForSignOff?.trim() ? service.reasonForSignOff : null,
          };

          // Only save rows that have meaningful data (you can adjust rule)
          const hasAnyValue = !!seaServiceData.companyName;
          if (!hasAnyValue) return null;

          if (service.id) {
            return updateSeaService(crewId, service.id, seaServiceData);
          }
          return createSeaService(crewId, seaServiceData);
        })
      );

      // ✅ reload from backend so UI reflects true state
      const latest = await getSeaServices(crewId);
      setExistingSeaServices(latest);

      const mapped = latest
        .sort((a, b) => (a.serialNo ?? 0) - (b.serialNo ?? 0))
        .map((item, idx) => ({
          id: item.id,
          serialNo: idx + 1,
          companyName: item.companyName || '',
          vesselName: item.vesselName || '',
          typeOfVesselFlag: item.typeOfVesselFlag || '',
          grtdrt: item.grtdrt || '',
          engineType: item.engineType || '',
          kwtBhp: item.kwtBhp || '',
          rank: item.rank || '',
          fromDate: item.fromDate || '',
          toDate: item.toDate || '',
          totalMonthsDays: item.totalMonthsDays || '',
          reasonForSignOff: item.reasonForSignOff || '',
        }));

      // keep at least 1 row visible
      setSeaServices(mapped.length ? mapped : [emptySeaServiceRow(1)]);

      setSavedTabs((s) => ({ ...s, seaService: true }));
      setSeaServiceSnapshot(JSON.stringify(mapped));
      toast.success('Sea Services updated');
      clearTopError();
      setActiveTab(nextTab('seaService'));
    } catch (err) {
      console.error('Failed to save sea services:', err);
      const msg = showErrorToast(err, 'Failed to save sea services.');
      setError(msg);
    } finally {
      setIsSubmittingTab(false)
    }
  };


  const handleFlagDocsSubmit = async () => {
    clearTopError()
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.')
      toast.warn('Please fill and save Personal Data first.')
      return
    }

    if (!flagDocsRef.current) {
      toast.warn('Flag Documents form is not ready.')
      return
    }

    setIsSubmittingTab(true)
    try {
      const ok = await flagDocsRef.current.saveAll()
      if (!ok) {
        setError('Failed to save flag documents.')
        toast.error('Failed to save flag documents.')
        return
      }

      setSavedTabs((s) => ({ ...s, flagDocs: true }))
      setIsFlagsDirty(false)
      clearTopError()
      setActiveTab(nextTab('flagDocs')) // moves to "banking"
    } catch (err) {
      console.error('Failed to save flag documents:', err)
      const msg = showErrorToast(err, 'Failed to save flag documents.')
      setError(msg)
    } finally {
      setIsSubmittingTab(false)
    }
  }

  const handleBankingDetailsSubmit = async () => {
    clearTopError()
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.')
      toast.warn('Please fill and save Personal Data first.')
      return
    }

    try {
      // Validate required fields
      const requiredFields = [
        'nameOfBeneficiary',
        'accountNumber',
        'bankName',
        'branchName',
        'branchCode',
        'ifscRtgsType',
        'bankAddress',
        'salaryCurrency',
        'basicWages',
        'leaveWages9DaysPerMonth',
        'otherAllowance',
        'overtimeRate',
      ]

      const fieldLabels: Record<string, string> = {
        nameOfBeneficiary: 'Name of Beneficiary',
        accountNumber: 'Account Number',
        bankName: 'Bank Name',
        branchName: 'Branch Name',
        branchCode: 'Branch Code',
        ifscRtgsType: 'Bank Code',
        ifscRtgsCode: 'IFSC / RTGS Code',
        swiftIandi: 'SWIFT / IBAN Code',
        bankAddress: 'Bank Address',
        salaryCurrency: 'Salary Currency',
        basicWages: 'Basic',
        fixedOvertime109Hrs: 'Fixed Overtime (109 Hrs)',
        leaveWages9DaysPerMonth: 'Leave Wages',
        subSmb: 'Sub / SMB',
        tradeAllowance: 'Trade Allowance',
        otherAllowance: 'Other Allowance',
        ownersLoyaltyBonus: "Owner's / Loyalty Bonus",
        rejoiningBonus: 'Re-joining Bonus',
        overtimeRate: 'Overtime Rate',
      }

      const errors: Record<string, string> = {}
      requiredFields.forEach((field) => {
        const value = bankingDetails[field]
        const isMissing =
          value === null ||
          value === undefined ||
          (typeof value === 'string' && !value.trim())

        if (isMissing) {
          errors[field] = `${fieldLabels[field] || field} is required`
        }
      })

      if (bankingDetails.ifscRtgsType === 'RTGS') {
        if (!bankingDetails.ifscRtgsCode || !bankingDetails.ifscRtgsCode.toString().trim()) {
          errors.ifscRtgsCode = 'IFSC / RTGS Code is required'
        }
      } else {
        if (!bankingDetails.swiftIandi || !bankingDetails.swiftIandi.toString().trim()) {
          errors.swiftIandi = 'SWIFT / IBAN Code is required'
        } else {
          const normalized = String(bankingDetails.swiftIandi).replace(/\s+/g, '').toUpperCase()
          const isSwift = /^[A-Z0-9]{8}([A-Z0-9]{3})?$/.test(normalized)
          const isIban = /^[A-Z0-9]{15,34}$/.test(normalized)
          if (!(isSwift || isIban)) {
            errors.swiftIandi = 'SWIFT / IBAN Code must be 8 or 11 characters (SWIFT) or 15-34 characters (IBAN)'
          }
        }
      }

      if (bankingDetails.salaryCurrency === 'OTHER' && !bankingDetails.salaryOtherCurrency) {
        errors['salaryOtherCurrency'] = 'Please specify the currency'
      }

      if (Object.keys(errors).length > 0) {
        setFieldErrors(errors)
        setError('Please fill all required fields in Banking Details.')
        toast.warn('Please complete all required banking details.')
        return
      }

      setIsSubmittingTab(true)

      const payload: BankingDetailsRequest = {
        crewId,
        nameOfBeneficiary: bankingDetails.nameOfBeneficiary || null,
        accountNumber: bankingDetails.accountNumber || null,
        bankName: bankingDetails.bankName || null,
        branchName: bankingDetails.branchName || null,
        branchCode: bankingDetails.branchCode || null,
        ifscRtgsType: bankingDetails.ifscRtgsType || 'IFSC',
        ifscRtgsCode: (bankingDetails.ifscRtgsCode || '').toString().trim(),
        swiftIandi: (bankingDetails.swiftIandi || '').toString().trim(),
        bankAddress: bankingDetails.bankAddress || null,
        accountCurrency: bankingDetails.accountCurrency || null,
        otherCurrency: bankingDetails.otherCurrency || null,
        salaryCurrency: bankingDetails.salaryCurrency || null,
        salaryOtherCurrency: bankingDetails.salaryOtherCurrency || null,
        remarks: bankingDetails.remarks || null,
        basicWages: bankingDetails.basicWages ?? null,
        fixedOvertime109Hrs: bankingDetails.fixedOvertime109Hrs ?? null,
        leaveWages9DaysPerMonth: bankingDetails.leaveWages9DaysPerMonth ?? null,
        subSmb: bankingDetails.subSmb ?? null,
        tradeAllowance: bankingDetails.tradeAllowance ?? null,
        otherAllowance: bankingDetails.otherAllowance ?? null,
        ownersLoyaltyBonus: bankingDetails.ownersLoyaltyBonus ?? null,
        rejoiningBonus: bankingDetails.rejoiningBonus ?? null,
        overtimeRate: bankingDetails.overtimeRate ?? null,
        unionSocialDues: bankingDetails.unionSocialDues || 'As per CBA',
        cashAdvanceFromOffice: bankingDetails.cashAdvanceFromOffice ?? null,
        deductionBond: bankingDetails.deductionBond ?? null,
        deductionInternetCard: bankingDetails.deductionInternetCard ?? null,
        otherDeductions: bankingDetails.otherDeductions ?? null,
        deductionsTotal: bankingDetails.deductionsTotal ?? null,
        salary: bankingDetails.salary ?? null,
      }

      let saved: BankingDetailsResponse
      if (existingBankingDetails?.id) {
        saved = await updateBankingDetails(crewId, existingBankingDetails.id, payload)
      } else {
        saved = await createBankingDetails(crewId, payload)
      }

      setExistingBankingDetails(saved)
      setBankingDetails({
        crewId: saved.crewId ?? crewId,
        nameOfBeneficiary: saved.nameOfBeneficiary || '',
        accountNumber: saved.accountNumber || '',
        bankName: saved.bankName || '',
        branchName: saved.branchName || '',
        branchCode: saved.branchCode || '',
        ifscRtgsType: saved.ifscRtgsType || 'IFSC',
        ifscRtgsCode: saved.ifscRtgsCode || '',
        swiftIandi: saved.swiftIandi || '',
        bankAddress: saved.bankAddress || '',
        accountCurrency: saved.accountCurrency || '',
        otherCurrency: saved.otherCurrency || '',
        salaryCurrency: saved.salaryCurrency || '',
        salaryOtherCurrency: saved.salaryOtherCurrency || '',
        remarks: saved.remarks || '',
        basicWages: saved.basicWages ?? null,
        fixedOvertime109Hrs: saved.fixedOvertime109Hrs ?? null,
        leaveWages9DaysPerMonth: saved.leaveWages9DaysPerMonth ?? null,
        subSmb: saved.subSmb ?? null,
        tradeAllowance: saved.tradeAllowance ?? null,
        otherAllowance: saved.otherAllowance ?? null,
        ownersLoyaltyBonus: saved.ownersLoyaltyBonus ?? null,
        rejoiningBonus: saved.rejoiningBonus ?? null,
        overtimeRate: saved.overtimeRate ?? null,
        unionSocialDues: saved.unionSocialDues || 'As per CBA',
        cashAdvanceFromOffice: saved.cashAdvanceFromOffice ?? null,
        deductionBond: saved.deductionBond ?? null,
        deductionInternetCard: saved.deductionInternetCard ?? null,
        otherDeductions: saved.otherDeductions ?? null,
        deductionsTotal: saved.deductionsTotal ?? null,
        salary: saved.salary ?? null,
      })

      setSavedTabs((s) => ({ ...s, banking: true }))
      setBankingDetailsSnapshot(JSON.stringify({
        crewId: saved.crewId ?? crewId,
        nameOfBeneficiary: saved.nameOfBeneficiary || '',
        accountNumber: saved.accountNumber || '',
        bankName: saved.bankName || '',
        branchName: saved.branchName || '',
        branchCode: saved.branchCode || '',
        ifscRtgsType: saved.ifscRtgsType || 'IFSC',
        ifscRtgsCode: saved.ifscRtgsCode || '',
        swiftIandi: saved.swiftIandi || '',
        bankAddress: saved.bankAddress || '',
        accountCurrency: saved.accountCurrency || '',
        otherCurrency: saved.otherCurrency || '',
        salaryCurrency: saved.salaryCurrency || '',
        salaryOtherCurrency: saved.salaryOtherCurrency || '',
        remarks: saved.remarks || '',
        basicWages: saved.basicWages ?? null,
        fixedOvertime109Hrs: saved.fixedOvertime109Hrs ?? null,
        leaveWages9DaysPerMonth: saved.leaveWages9DaysPerMonth ?? null,
        subSmb: saved.subSmb ?? null,
        tradeAllowance: saved.tradeAllowance ?? null,
        otherAllowance: saved.otherAllowance ?? null,
        ownersLoyaltyBonus: saved.ownersLoyaltyBonus ?? null,
        rejoiningBonus: saved.rejoiningBonus ?? null,
        overtimeRate: saved.overtimeRate ?? null,
        unionSocialDues: saved.unionSocialDues || 'As per CBA',
        cashAdvanceFromOffice: saved.cashAdvanceFromOffice ?? null,
        deductionBond: saved.deductionBond ?? null,
        deductionInternetCard: saved.deductionInternetCard ?? null,
        otherDeductions: saved.otherDeductions ?? null,
        deductionsTotal: saved.deductionsTotal ?? null,
        salary: saved.salary ?? null,
      }))
      clearTopError()
      toast.success('Banking details saved successfully!')
      setActiveTab(nextTab('banking')) // moves to "other"
    } catch (err) {
      console.error('Failed to save banking details:', err)
      const msg = showErrorToast(err, 'Failed to save banking details.')
      setError(msg)
    } finally {
      setIsSubmittingTab(false)
    }
  }

  const handleAdditionalDetailsSubmit = async () => {
    clearTopError();
    if (!crewId) {
      setError('Please fill and save Personal Data first to create a crew member.');
      toast.warn('Please fill and save Personal Data first.');
      return;
    }

    setIsSubmittingTab(true)
    try {
      const additionalDetailsData: AdditionalDetailsRequest = {
        crewId: crewId!,
        criminalCaseInvolved: additionalDetails.criminalCaseInvolved ?? false,
        criminalCaseDetails: additionalDetails.criminalCaseDetails || null,
        certificateSuspendedRevoked: additionalDetails.certificateSuspendedRevoked ?? false,
        certificateSuspendedRevokedDetails: additionalDetails.certificateSuspendedRevokedDetails || null,
        hasMedicalConditions: additionalDetails.hasMedicalConditions ?? false,
        medicalConditionsDetails: additionalDetails.medicalConditionsDetails || null,
        habitualUseDrugsAlcohol: additionalDetails.habitualUseDrugsAlcohol ?? false,
        habitualUseDetails: additionalDetails.habitualUseDetails || null,
        workedWithMultinational: additionalDetails.workedWithMultinational ?? false,
        multinationalNationalities: additionalDetails.multinationalNationalities || null,
        referralSource: additionalDetails.referralSource || null,
        referralDetails: additionalDetails.referralDetails || null,
        pumpExperienceFramoMonths: additionalDetails.pumpExperienceFramoMonths || null,
        pumpExperienceCopMonths: additionalDetails.pumpExperienceCopMonths || null,
        drydockingExperience: additionalDetails.drydockingExperience ?? false,
        drydockingRank: additionalDetails.drydockingRank || null,
        newConstructionExperience: additionalDetails.newConstructionExperience ?? false,
        newConstructionRank: additionalDetails.newConstructionRank || null,
        incidentInvolvement: additionalDetails.incidentInvolvement ?? false,
        incidentDetails: additionalDetails.incidentDetails || null,
        courtOfEnquiryInvolvement: additionalDetails.courtOfEnquiryInvolvement ?? false,
        courtOfEnquiryDetails: additionalDetails.courtOfEnquiryDetails || null,
        references: additionalDetails.hasReferenceData ? JSON.stringify(references) : '[]',
        declarationMedicalExam: additionalDetails.declarationMedicalExam ?? false,
        declarationMedicalDecision: additionalDetails.declarationMedicalDecision ?? false,
        declarationNoCriminal: additionalDetails.declarationNoCriminal ?? false,
        declarationDocumentsValid: additionalDetails.declarationDocumentsValid ?? false,
        declarationNotEmployed: additionalDetails.declarationNotEmployed ?? false,
        declarationNoAgents: additionalDetails.declarationNoAgents ?? false,
        availabilityDate: additionalDetails.availabilityDate || null,
        applicantName: additionalDetails.applicantName || null,
        applicantDate: additionalDetails.applicantDate || null,
        hasReferenceData: additionalDetails.hasReferenceData ?? false,
      };
      let updated;
      updated = await createAdditionalDetails(crewId, additionalDetailsData);
      setExistingAdditionalDetails(updated);
      toast.success('Additional Details saved');
      setSavedTabs((s) => ({ ...s, other: true }));
      setAdditionalDetailsSnapshot(JSON.stringify({ ...additionalDetailsData, references }));
      clearTopError();
      if (showCrewMatrix) {
        setActiveTab(nextTab('other'))
      } else {
        localStorage.removeItem(DRAFT_KEY)
        onClose()
      }
    } catch (err) {
      console.error('Failed to save additional details:', err);
      const msg = showErrorToast(err, 'Failed to save additional details.');
      setError(msg);
    } finally {
      setIsSubmittingTab(false)
    }
  };

const POPULAR_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.in',
  'yahoo.in',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'mail.com',
  'protonmail.com',
  'proton.me',
  'aol.com',
  'zoho.com',
  'yandex.com',
  'fastmail.com',
]

const isPopularEmailDomain = (email: string): boolean => {
  const match = String(email ?? '').trim().match(/^[a-z0-9._%+-]+@([a-z0-9.-]+\.[a-z]{2,})$/i)
  if (!match) return false
  const domain = match[1].toLowerCase()
  return POPULAR_EMAIL_DOMAINS.includes(domain)
}

  const validateField = (field: string, value: any): string => {
    switch (field) {
      case 'name':
        return !value.trim() ? 'Name is required' : ''
      case 'familyName':
        return !value.trim() ? 'Family Name is required' : ''
      case 'contactNumber':
        if (!value.trim()) return 'Mobile number is required'
        return !/^\+?[0-9\s\-()]{7,20}$/.test(value) ? 'Invalid mobile number' : ''
      case 'alternateMobNo':
        if (!value.trim()) return 'Alternate mobile number is required'
        return !/^\+?[0-9\s\-()]{7,20}$/.test(value) ? 'Invalid alternate mobile number' : ''
      case 'email':
        if (!value.trim()) return 'Email is required'
        if (!isValidEmailDomain(value)) return 'Please enter a valid email address with a complete domain (e.g. example@gmail.com)'
        return ''
      case 'nationality':
        return !value.trim() ? 'Nationality is required' : ''
      case 'placeOfBirth':
        return !value.trim() ? 'Place of Birth is required' : ''
      case 'dateOfAvailability':
        return !value ? 'Date of Availability is required' : ''
      case 'dateOfJoining':
        return ''
      case 'maritalStatus':
        return !value.trim() ? 'Marital Status is required' : ''
      case 'department':
        return !value.trim() ? 'Department is required' : ''
      case 'presentRankId':
        return value === '' ? 'Present Rank is required' : ''
      case 'rankAppliedForId':
        return value === '' ? 'Applied Rank is required' : ''
      case 'bloodGroup':
        return !value.trim() ? 'Blood Group is required' : ''
      case 'heightCms':
        return value <= 0 ? 'Height must be greater than 0' : ''
      case 'weightKgs':
        return value <= 0 ? 'Weight must be greater than 0' : ''
      case 'bmiIndex':
        return value <= 0 ? 'BMI Index must be greater than 0' : ''
      case 'willingToAcceptLowerRank':
        return value === undefined || value === null
          ? 'Willing to Accept Lower Rank is required'
          : ''
      case 'address':
        return !value.trim() ? 'Address is required' : ''
      case 'companyAdmin':
        return roleId === 1 && !value.id ? 'Company selection is required' : ''
      case 'dateOfBirth':
        if (!value) return 'Date of Birth is required'
        const age = calculateAge(value)
        return age < 18 ? 'You must be at least 18 years old' : ''
      default:
        return ''
    }
  }

  const handleFieldChange = (field: string, value: any, setter: (value: any) => void) => {
    setter(value)
    const error = validateField(field, value)
    setFieldErrors((prev) => ({
      ...prev,
      [field]: error,
    }))
  }

  // REPLACE THIS WHOLE FUNCTION
  const validateFields = () => {
    const errors: Record<string, string> = {}

    // --- DOB: must be at least 18 as of today ---
    const toDate = (d: any): Date | null => {
      if (!d) return null
      return d instanceof Date ? d : new Date(d)
    }
    const dob = toDate(dateOfBirth)
    const today = new Date()
    const cutoff = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
    errors.dateOfBirth = !dob
      ? 'Date of Birth is required'
      : (dob > cutoff ? 'You must be at least 18 years old as of today' : '')

    // --- existing validations ---
    errors.name = validateField('name', name)
    // errors.familyName = validateField('familyName', familyName)
    errors.contactNumber = validateField('contactNumber', contactNumber)
    errors.alternateMobNo = validateField('alternateMobNo', alternateMobNo)
    errors.email = validateField('email', email)
    errors.nationality = validateField('nationality', nationality)
    errors.placeOfBirth = validateField('placeOfBirth', placeOfBirth)
    errors.dateOfAvailability = validateField('dateOfAvailability', dateOfAvailability)
    // errors.maritalStatus = validateField('maritalStatus', maritalStatus)
    errors.department = validateField('department', department)
    errors.presentRankId = validateField('presentRankId', presentRankId)
    errors.rankAppliedForId = validateField('rankAppliedForId', rankAppliedForId)
    // errors.bloodGroup = validateField('bloodGroup', bloodGroup)
    // errors.heightCms = validateField('heightCms', heightCms)
    // errors.weightKgs = validateField('weightKgs', weightKgs)
    // errors.bmiIndex = validateField('bmiIndex', bmiIndex)
    errors.willingToAcceptLowerRank = validateField('willingToAcceptLowerRank', willingToAcceptLowerRank)
    errors.address = validateField('address', address)
    errors.companyAdmin = validateField('companyAdmin', selectedCompanyAdmin)

    // uploads pairing checks
    certifications.forEach((cert, index) => {
      if (!cert.documentName.trim() && cert.file) {
        errors[`certification_${index}`] = 'Document name is required when a file is selected.'
      }
      if (cert.documentName.trim() && !cert.file) {
        errors[`certification_${index}`] = 'A file is required when document name is provided.'
      }
    })

    documents.forEach((doc, index) => {
      if (!doc.documentName.trim() && doc.file) {
        errors[`document_${index}`] = 'Document name is required when a file is selected.'
      }
      if (doc.documentName.trim() && !doc.file) {
        errors[`document_${index}`] = 'A file is required when document name is provided.'
      }
    })

    // Sub Company required only for Company Group Admin (role 5)
    if (roleId === 5 && companies.length > 0 && !selectedCompany.id) {
      errors.selectedCompany = 'Sub Company is required'
    }

    // Mandatory National CDC validation
    if (!documentForm.cdcNumber?.trim()) {
      errors.cdcNumber = 'CDC Number is required'
    }
    if (!documentForm.cdcIssueDate?.trim()) {
      errors.cdcIssueDate = 'CDC Date of Issue is required'
    }
    if (!documentForm.cdcPlaceOfIssue?.trim()) {
      errors.cdcPlaceOfIssue = 'CDC Place of Issue is required'
    }
    if (!documentForm.cdcExpiryDate?.trim()) {
      errors.cdcExpiryDate = 'CDC Date of Expiry is required'
    }

    setFieldErrors(errors)
    return Object.values(errors).every((e) => !e)
  }


  const calculateAge = (dob: Date | null): number => {
    if (!dob) return 0 // Handle null value for dateOfBirth
    const diff = Date.now() - dob.getTime()
    const ageDate = new Date(diff)
    return Math.abs(ageDate.getUTCFullYear() - 1970)
  }

  // REPLACE the existing generateUsername with this robust one
  const generateUsername = (crewName: string) => {
    const base = (crewName || 'crew')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')

    // timestamp + cryptographically-strong random suffix => practically unique
    const ts = Date.now().toString(36)
    const rand = (() => {
      if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
        const bytes = new Uint8Array(6)
        window.crypto.getRandomValues(bytes)
        // base36-ish string (no custom colors or styles :)
        return Array.from(bytes, b => (b % 36).toString(36)).join('')
      }
      return Math.random().toString(36).slice(2, 8)
    })()

    return `${base || 'crew'}_${ts}${rand}`
  }


  const generatePassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$!'
    return Array.from({ length: 10 }, () => chars[Math.floor(Math.random() * chars.length)]).join('')
  }

  // --- helper near top of file (add once, outside the component or above handleSavePersonal) ---
  const toYMD = (d: Date | null | undefined): string | undefined => {
    if (!d) return undefined;
    // make it timezone-agnostic "YYYY-MM-DD"
    const dt = new Date(d);
    dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
    return dt.toISOString().slice(0, 10);
  };

  const handleSendOnboardingMail = async () => {
    if (!name.trim() || !email.trim()) return

    setOnboardingLoading(true)
    try {
      const ownership = resolveCrewCreateOwnership({
        roleId,
        roleEntityId,
        effectiveBehaviorType: resolveEffectiveBehaviorType(currentUser as Record<string, unknown>, {roleDetails, tenant}),
        companyGroupAdminId: cgaId,
        companyAdminId: caId,
        isSuperAdmin: roleId === 1,
        operatorCompanyGroupAdminId: cgaId,
        operatorCompanyAdminId: caId,
        selectedCompanyGroupAdminId:
          roleId === 1 || isSuperadminOperator ? selectedCompanyAdmin.id : undefined,
        selectedCompanyAdminId:
          roleId === 5 || isGroupOperator || roleId === 1 || isSuperadminOperator
            ? selectedCompany.id
            : undefined,
      })

      if (!ownership) {
        toast.error('Unable to resolve company ownership for this user.')
        return
      }

      const generatedUsername = generateUsername(name)
      const generatedPassword = generatePassword()

      const payload = {
        id: crewId || undefined,
        name: name.trim(),
        email: email.trim(),
        username: generatedUsername,
        password: generatedPassword,
        companyGroupAdminId: ownership.companyGroupAdminId,
        companyAdminId: ownership.companyAdminId ?? null,
        presentRankId: presentRankId || undefined,
        rankAppliedForId: rankAppliedForId || undefined,
        rankId: presentRankId || rankAppliedForId || undefined,
        employeeId: employeeId || undefined,
        familyName: familyName || undefined,
        telNo: telNo || undefined,
        contactNumber: contactNumber || undefined,
        alternateMobNo: alternateMobNo || undefined,
        dateOfBirth: dateOfBirth ? toYMD(dateOfBirth) : undefined,
        skypeId: skypeId || undefined,
        nationality: nationality || undefined,
        placeOfBirth: placeOfBirth || undefined,
        dateOfAvailability: dateOfAvailability ? toYMD(dateOfAvailability) : undefined,
        dateOfJoining: dateOfJoining ? toYMD(dateOfJoining) : undefined,
        maritalStatus: maritalStatus || undefined,
        department: department || undefined,
        willingToAcceptLowerRank: willingToAcceptLowerRank || false,
        boilerSuitSize: boilerSuitSize || undefined,
        heightCms: heightCms || undefined,
        weightKgs: weightKgs || undefined,
        bmiIndex: bmiIndex || undefined,
        bloodGroup: bloodGroup || undefined,
        shoeSize: shoeSize || undefined,
        address: address || undefined,
        notes: notes || undefined,
      }

      const response = await initiateCrewOnboarding(payload)

      if (response.crewId) {
        setCrewId(response.crewId)
        if (response.username) setGeneratedUsername(response.username)
        if (response.password) setGeneratedPassword(response.password)
        setSavedTabs((s) => ({ ...s, personal: true }))
        setPersonalSnapshot(JSON.stringify(personalForm))

        if (documentForm.cdcNumber?.trim()) {
          try {
            if (existingDocument?.id) {
              await updateCrewDocument(response.crewId, existingDocument.id, documentForm)
            } else {
              const createdDoc = await createCrewDocument(response.crewId, documentForm)
              setExistingDocument(createdDoc)
            }
          } catch (docErr) {
            console.error('Failed to sync CDC document during initiate onboarding', docErr)
          }
        }
      }
      setOnboardingLink(response.onboardingLink)
      setOnboardingSent(true)
      toast.success(response.message || 'Onboarding email sent and candidate account provisioned!')
    } catch (err: any) {
      showErrorToast(err, 'Failed to send onboarding email')
    } finally {
      setOnboardingLoading(false)
    }
  }

  const handleSavePersonal = async () => {
    clearTopError();
    setError('');
    if (!validateFields()) {
      toast.warn('Please fill out the form correctly.');
      return;
    }

    setIsSubmittingTab(true);

    // Sub-company is optional for Company Group Admin — crew may be owned at group level.

    try {
      const loginLink = `${app_link}/auth/${selectedVessel?.vesselType}/${selectedVessel?.imoNumber}/ship-login`;

      const ownership = resolveCrewCreateOwnership({
        roleId,
        roleEntityId,
        effectiveBehaviorType: resolveEffectiveBehaviorType(currentUser as Record<string, unknown>, {roleDetails, tenant}),
        companyGroupAdminId: cgaId,
        companyAdminId: caId,
        isSuperAdmin: roleId === 1,
        operatorCompanyGroupAdminId: cgaId,
        operatorCompanyAdminId: caId,
        selectedCompanyGroupAdminId:
          roleId === 1 || isSuperadminOperator ? selectedCompanyAdmin.id : undefined,
        selectedCompanyAdminId:
          roleId === 5 || isGroupOperator || roleId === 1 || isSuperadminOperator
            ? selectedCompany.id
            : undefined,
      })

      if (!ownership) {
        toast.error('Unable to resolve company ownership for this user.')
        return
      }

      const { companyGroupAdminId, companyAdminId } = ownership

      if (documentForm.cdcNumber?.trim()) {
        const ntbeRes = await checkCrewNtbe({
          cdcNumber: documentForm.cdcNumber.trim(),
          companyGroupAdminId: roleId === 1 || isSuperadminOperator ? companyGroupAdminId || undefined : undefined,
        })
        if (ntbeRes.isNtbe) {
          setFieldErrors((prev) => ({
            ...prev,
            cdcNumber: 'This seafarer is marked as NTBE (Not To Be Employed) in this company/group.',
          }))
          toast.error(ntbeRes.message || 'Seafarer is marked as NTBE (Not To Be Employed).')
          return
        }
      }

      if (!crewId) {
        // ---------------- CREATE with auto-retry on duplicate username ----------------
        let attempts = 0
        let created: Crew | null = null
        let finalUsername = ''
        let finalPassword = ''

        while (attempts < 3 && !created) {
          const username = generateUsername(name)
          const password = generatePassword()

          try {
            const resp = await createCrew(
              name,
              dateOfBirth ?? new Date(),
              nationality,
              department,
              contactNumber,
              email,
              username,
              password,
              Number(presentRankId),
              companyGroupAdminId,
              companyAdminId,
              certifications.filter((c) => c.file),
              documents.filter((d) => d.file),
              Number(presentRankId),
              rankAppliedForId ? Number(rankAppliedForId) : null,
              telNo,
              familyName,
              alternateMobNo,
              skypeId,
              maritalStatus,
              bloodGroup,
              heightCms,
              weightKgs,
              bmiIndex,
              willingToAcceptLowerRank,
              boilerSuitSize,
              shoeSize,
              address,
              placeOfBirth,
              dateOfAvailability ?? new Date(),
              dateOfJoining,
              notes,
              employeeId || undefined,
            )

            created = resp
            finalUsername = username
            finalPassword = password
          } catch (err: any) {
            const msg = err?.response?.data?.message || ''
            const duplicate =
              /Duplicate entry/i.test(msg) && /UKr43af9ap4edm43mmtq01oddj6/i.test(msg)
            if (!duplicate) {
              throw err
            }
            attempts += 1
            // loop again with a new username
          }
        }

        if (!created) {
          throw new Error('Could not generate a unique username after several attempts.')
        }

        setCrewId(created.id)
        setGeneratedUsername(finalUsername)
        setGeneratedPassword(finalPassword)
        setLoginLink(loginLink)

        if (documentForm.cdcNumber?.trim()) {
          try {
            if (existingDocument?.id) {
              await updateCrewDocument(created.id, existingDocument.id, documentForm)
            } else {
              const createdDoc = await createCrewDocument(created.id, documentForm)
              setExistingDocument(createdDoc)
            }
            setSavedTabs((s) => ({ ...s, documents: true }))
            setDocumentSnapshot(JSON.stringify(documentForm))
          } catch (docErr) {
            console.error('Failed to sync CDC document in handleSavePersonal', docErr)
          }
        }

        setSavedTabs((s) => ({ ...s, personal: true }))
        setPersonalSnapshot(JSON.stringify(personalForm))
        toast.success('Personal Data saved. Crew created.')
        onCrewAdded({ password: finalPassword, link: loginLink, created })
        setActiveTab(nextTab('personal'))
        return
      }
      // UPDATE
      await updateCrew(crewId, {
        name,
        dateOfBirth: (dateOfBirth ?? new Date()).toISOString().split('T')[0],
        nationality,
        department,
        contactNumber,
        email,
        rankId: Number(rankAppliedForId) || Number(presentRankId), // Use rankAppliedForId if available, else presentRankId
        presentRankId: Number(presentRankId),
        rankAppliedForId: rankAppliedForId ? Number(rankAppliedForId) : undefined,
        companyGroupAdminId, // Use corrected ID
        companyAdminId, // Use corrected ID
        active: true,
        notes,
        familyName,
        placeOfBirth,
        gender: '', // Add if needed
        telNo,
        alternateMobNo,
        skypeId,
        dateOfAvailability: dateOfAvailability
          ? dateOfAvailability.toISOString().split('T')[0]
          : undefined,
        dateOfJoining: dateOfJoining
          ? dateOfJoining.toISOString().split('T')[0]
          : undefined,
        maritalStatus,
        bloodGroup,
        heightCms,
        weightKgs,
        bmiIndex,
        willingToAcceptLowerRank,
        boilerSuitSize,
        shoeSize,
        address,
        // isApproved: false,
      });

      if (documentForm.cdcNumber?.trim()) {
        try {
          if (existingDocument?.id) {
            await updateCrewDocument(crewId, existingDocument.id, documentForm)
          } else {
            const createdDoc = await createCrewDocument(crewId, documentForm)
            setExistingDocument(createdDoc)
          }
          setSavedTabs((s) => ({ ...s, documents: true }))
          setDocumentSnapshot(JSON.stringify(documentForm))
        } catch (docErr) {
          console.error('Failed to sync CDC document in handleSavePersonal', docErr)
        }
      }

      setSavedTabs((s) => ({ ...s, personal: true }));
      setPersonalSnapshot(JSON.stringify(personalForm));
      toast.success('Personal updated');
      // before navigating forward, make sure any previous error is cleared
      clearTopError();
      setActiveTab(nextTab('personal'));

    } catch (err: any) {
      console.error('Error saving personal data:', err);
      const errorMessage = showErrorToast(err, 'Failed to save Personal');
      setError(errorMessage);
    } finally {
      setIsSubmittingTab(false);
    }
  };

  const clearForm = () => {
    if (activeTab === 'personal' && !savedTabs.personal) {
      setName('')
      setDateOfBirth(null)
      setNationality('')
      setDepartment('')
      setContactNumber('')
      setEmail('')
      setPresentRankId('')
      setRankAppliedForId('')
      setBloodGroup('')
      setFamilyName('')
      setTelNo('')
      setAlternateMobNo('')
      setSkypeId('')
      setMaritalStatus('')
      setHeight(0)
      setWeight(0)
      setBmiIndex(0)
      setWillingToAcceptLowerRank(false)
      setBoilerSuitSize('')
      setShoeSize('')
      setAddress('')
      setPlaceOfBirth('')
      setDateOfAvailability(null)
      setDateOfJoining(new Date())
      setSelectedCompany({ id: 0, name: '' })
      setSelectedCompanyAdmin({ id: 0, name: '' })
      setFieldErrors({})
      setPersonalSnapshot(JSON.stringify({}))
      toast.success('Personal form cleared')
    } else if (activeTab === 'documents' && !savedTabs.documents) {
      setDocumentForm({})
      setFieldErrors({})
      setDocumentSnapshot(JSON.stringify({}))
      toast.success('Documents form cleared')
    } else if (activeTab === 'academic' && !savedTabs.academic) {
      setAcademicBackgrounds([
        {
          qualification: '',
          institutionName: '',
          boardOrUniversity: '',
          dateOfPassing: '',
          gradeOrPercentage: '',
          englishProficiency: '',
        },
      ])
      setFieldErrors({})
      setAcademicSnapshot(JSON.stringify([]))
      toast.success('Academic form cleared')
    } else if (activeTab === 'watchkeeping' && !savedTabs.watchkeeping) {
      setWatchkeepingCertificates(
        certificateDetails.map((detail) => ({
          certificateDetails: detail,
          certificateNo: '',
          dateOfIssue: '',
          placeOfIssue: '',
          validUntil: '',
        }))
      )
      setFieldErrors({})
      setWatchkeepingSnapshot(
        JSON.stringify(
          certificateDetails.map((detail) => ({
            certificateDetails: detail,
            certificateNo: '',
            dateOfIssue: '',
            placeOfIssue: '',
            validUntil: '',
          }))
        )
      )
      toast.success('Watchkeeping Certificates form cleared')
    } else if (activeTab === 'kin' && !savedTabs.kin) {
      setNextOfKin({
        crewId: crewId || 0,
        civilStatus: null,
        fullName: '',
        relationship: '',
        address: '',
        pinCode: '',
        phoneStdCode: '',
        phoneNumber: '',
      });
      setFieldErrors({});
      setNextOfKinSnapshot(JSON.stringify({}));
      toast.success('Next of Kin form cleared');
    } else if (activeTab === 'courses' && !savedTabs.courses) {
      const cleanState = buildCourseCertificateState();
      setCourseCertificates(cleanState);
      setFieldErrors({});
      setCourseCertificatesSnapshot(JSON.stringify(cleanState));
      toast.success('Course Certificates form cleared');
    } else if (activeTab === 'seaService' && !savedTabs.seaService) {
      setSeaServices([
        {
          serialNo: 1,
          companyName: '',
          vesselName: '',
          typeOfVesselFlag: '',
          grtdrt: '',
          engineType: '',
          kwtBhp: '',
          rank: '',
          fromDate: '',
          toDate: '',
          totalMonthsDays: '',
          reasonForSignOff: '',
        },
      ]);
      setFieldErrors({});
      setSeaServiceSnapshot(JSON.stringify([]));
      toast.success('Sea Service form cleared');
    } else if (activeTab === 'other' && !savedTabs.other) {
      setAdditionalDetails({
        crewId: crewId || 0,
        criminalCaseInvolved: false,
        criminalCaseDetails: '',
        certificateSuspendedRevoked: false,
        certificateSuspendedRevokedDetails: '',
        hasMedicalConditions: false,
        medicalConditionsDetails: '',
        habitualUseDrugsAlcohol: false,
        habitualUseDetails: '',
        workedWithMultinational: false,
        multinationalNationalities: '',
        referralSource: null,
        referralDetails: '',
        pumpExperienceFramoMonths: null,
        pumpExperienceCopMonths: null,
        drydockingExperience: false,
        drydockingRank: '',
        newConstructionExperience: false,
        newConstructionRank: '',
        incidentInvolvement: false,
        incidentDetails: '',
        courtOfEnquiryInvolvement: false,
        courtOfEnquiryDetails: '',
        references: '[]',
        declarationMedicalExam: false,
        declarationMedicalDecision: false,
        declarationNoCriminal: false,
        declarationDocumentsValid: false,
        declarationNotEmployed: false,
        declarationNoAgents: false,
        availabilityDate: '',
        applicantName: '',
        applicantDate: '',
        hasReferenceData: false,
      });

      setReferences([{ srNo: 1, companyName: '', pic: '', designation: '', phoneNo: '' }]);
      setFieldErrors({});
      setAdditionalDetailsSnapshot(JSON.stringify({}));
      toast.success('Additional Details form cleared');
    }
    persistDraft() // Update draft to reflect cleared form
  }

  const hasUnsavedChanges =
    isPersonalDirty || isDocumentDirty || isAcademicDirty || isWatchkeepingDirty || isNextOfKinDirty || isCoursesDirty || isSeaServiceDirty || isFlagsDirty || isBankingDetailsDirty || isAdditionalDetailsDirty
  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [hasUnsavedChanges])

  if (!isOpen) return null

  return (
    <div className='modal-overlay'>
      <div
        className='modal-content'
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '115rem' }}
      >
        <div className='custom-modal-header d-flex justify-content-between align-items-center'>
          <h5 className='m-0'>Add Crew</h5>
          <span className='d-flex align-items-center gap-2'>
            {generatedPassword && savedTabs.personal && (
              <div className='d-flex align-items-center bg-light p-2 rounded '>
                <span className=' me-2'>Password for Crew Login:&nbsp; {generatedPassword}</span> &nbsp;
                <button
                  className='btn btn-sm btn-primary text-nowrap'
                  onClick={() => {
                    navigator.clipboard.writeText(generatedPassword)
                    toast.success('Password copied to clipboard')
                  }}
                  title='Copy Password'
                >
                  {`  Copy  `}
                  {/* <KTSVG path='/media/map/copy.svg' className='svg-icon-2' /> */}
                </button>
              </div>
            )}
            <button className='btn btn-sm btn-secondary' onClick={clearForm}>
              Clear Form
            </button>{' '}</span>
          <button className='close-btn' onClick={onClose}>
            <KTSVG path='/media/map/x.svg' className='svg-icon-2x' />
          </button>

        </div>

        <ul className='nav nav-tabs mb-4'>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'personal' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('personal')}
            >
              Personal Data {savedTabs.personal && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'documents' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('documents')}
            >
              Documents {savedTabs.documents && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'academic' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('academic')}
            >
              Academic Background{' '}
              {savedTabs.academic && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'watchkeeping' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('watchkeeping')}
            >
              Watch Keeping Certificates{' '}
              {savedTabs.watchkeeping && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'kin' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('kin')}
            >
              Next of Kin Details {savedTabs.kin && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'banking' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('banking')}
            >
              Banking Details {savedTabs.banking && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'courses' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('courses')}
            >
              Courses & Certificates{' '}
              {savedTabs.courses && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'seaService' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('seaService')}
            >
              Previous Sea Service{' '}
              {savedTabs.seaService && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'flagDocs' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('flagDocs')}
            >
              Flag Document{' '}
              {savedTabs.flagDocs && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`nav-link ${activeTab === 'other' ? 'active' : ''}`}
              onClick={() => safeSetActiveTab('other')}
            >
              Other Details {savedTabs.other && <span className='text-success ms-1'>✓</span>}
            </button>
          </li>
          {showCrewMatrix && (
            <li className='nav-item'>
              <button
                className={`nav-link ${activeTab === 'crewMatrix' ? 'active' : ''}`}
                onClick={() => safeSetActiveTab('crewMatrix')}
              >
                Crew Matrix
              </button>
            </li>
          )}
        </ul>

        <div className='custom-modal-body'>
          {error && <div className='alert alert-danger'>{error}</div>}

          <div className='row'>
            {activeTab === 'personal' && (
              <PersonalData
                presentRankId={presentRankId}
                setPresentRankId={setPresentRankId}
                rankAppliedForId={rankAppliedForId}
                setRankAppliedForId={setRankAppliedForId}
                employeeId={employeeId}
                setEmployeeId={setEmployeeId}
                familyName={familyName}
                setFamilyName={setFamilyName}
                telNo={telNo}
                setTelNo={setTelNo}
                name={name}
                setName={setName}
                contactNumber={contactNumber}
                setContactNumber={setContactNumber}
                email={email}
                setEmail={setEmail}
                alternateMobNo={alternateMobNo}
                setAlternateMobNo={setAlternateMobNo}
                dateOfBirth={dateOfBirth}
                setDateOfBirth={setDateOfBirth}
                skypeId={skypeId}
                setSkypeId={setSkypeId}
                nationality={nationality}
                setNationality={setNationality}
                placeOfBirth={placeOfBirth}
                setPlaceOfBirth={setPlaceOfBirth}
                dateOfAvailability={dateOfAvailability}
                setDateOfAvailability={setDateOfAvailability}
                dateOfJoining={dateOfJoining}
                setDateOfJoining={setDateOfJoining}
                maritalStatus={maritalStatus}
                setMaritalStatus={setMaritalStatus}
                department={department}
                setDepartment={setDepartment}
                willingToAcceptLowerRank={willingToAcceptLowerRank}
                setWillingToAcceptLowerRank={setWillingToAcceptLowerRank}
                boilerSuitSize={boilerSuitSize}
                setBoilerSuitSize={setBoilerSuitSize}
                heightCms={heightCms}
                setHeight={setHeight}
                weightKgs={weightKgs}
                setWeight={setWeight}
                bmiIndex={bmiIndex}
                setBmiIndex={setBmiIndex}
                bloodGroup={bloodGroup}
                setBloodGroup={setBloodGroup}
                shoeSize={shoeSize}
                setShoeSize={setShoeSize}
                address={address}
                setAddress={setAddress}
                notes={notes}
                setNotes={setNotes}
                roleId={roleId}
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                selectedCompanyAdmin={selectedCompanyAdmin}
                setSelectedCompanyAdmin={setSelectedCompanyAdmin}
                companies={companies}
                companyAdmins={companyAdmins}
                companiesbyAdmin={companiesbyAdmin}
                fetchCompaniesByAdmin={fetchCompaniesByAdmin}
                roleEntityId={roleEntityId}
                fieldErrors={fieldErrors}
                ranks={ranks}
                bloodGroupOptions={bloodGroupOptions}
                lockCoreFields={coreLocked}
                operatorActsLikeSuperadmin={operatorActsLikeSuperadmin}
                operatorActsLikeGroupAdmin={operatorActsLikeGroupAdmin}
                cdcNumber={documentForm.cdcNumber || ''}
                setCdcNumber={(v) => handleDocumentFormChange('cdcNumber', v)}
                cdcIssueDate={documentForm.cdcIssueDate || ''}
                setCdcIssueDate={(v) => handleDocumentFormChange('cdcIssueDate', v)}
                cdcPlaceOfIssue={documentForm.cdcPlaceOfIssue || ''}
                setCdcPlaceOfIssue={(v) => handleDocumentFormChange('cdcPlaceOfIssue', v)}
                cdcExpiryDate={documentForm.cdcExpiryDate || ''}
                setCdcExpiryDate={(v) => handleDocumentFormChange('cdcExpiryDate', v)}
                unionMembershipNo={documentForm.unionMembershipNo || ''}
                setUnionMembershipNo={(v) => handleDocumentFormChange('unionMembershipNo', v)}
              >
              {/* Send Invite Email trigger button — shown only when name & email are completely valid with proper domain */}
              {name.trim() && isValidEmailDomain(email) && (

                <div className='col-12 mt-3'>
                  <button
                    className='btn btn-outline-primary btn-sm'
                    onClick={() => setShowInvitePopup(true)}
                  >
                    <KTSVG path='/media/icons/duotune/communication/com005.svg' className='svg-icon-2 me-2' />
                    Invite Crew via Email
                  </button>
                </div>
              )}
              </PersonalData>
            )}

            {/* ===== INVITE CREW POPUP ===== */}
            {showInvitePopup && (
              <div style={{
                position:'fixed', top:0, left:0, right:0, bottom:0,
                background:'rgba(0,0,0,0.5)', display:'flex',
                alignItems:'center', justifyContent:'center', zIndex:99999,
              }}
                onClick={(e) => { if (e.target === e.currentTarget) setShowInvitePopup(false) }}
              >
                <div style={{
                  background:'#fff', borderRadius:12, maxWidth:560, width:'100%',
                  maxHeight:'90vh', overflow:'auto', boxShadow:'0 8px 40px rgba(0,0,0,0.2)',
                }} onClick={(e) => e.stopPropagation()}>
                  <div className='d-flex justify-content-between align-items-center p-4 border-bottom'>
                    <h5 className='mb-0 d-flex align-items-center gap-2'>
                      <KTSVG path='/media/icons/duotune/communication/com005.svg' className='svg-icon-2 svg-icon-primary' />
                      Invite Crew via Email
                    </h5>
                    <button className='btn btn-sm btn-icon btn-light' onClick={() => setShowInvitePopup(false)}>
                      <KTSVG path='/media/map/x.svg' className='svg-icon-2' />
                    </button>
                  </div>
                  <div className='p-4'>
                    <div className='bg-light rounded p-4 mb-4'>
                      <h6 className='fw-bold mb-3'>📧 Email Summary</h6>
                      <div className='d-flex flex-column gap-2'>
                        <div><strong>To:</strong> {email}</div>
                        <div><strong>Subject:</strong> ShipsEdge — Complete Your Crew Profile</div>
                        <div><strong>Crew Member:</strong> {name}</div>
                      </div>
                      <p className='text-muted small mt-2 mb-0'>
                        The link is valid for 24 hours and can only be used once.
                      </p>
                    </div>

                    {!onboardingSent ? (
                      <button
                        className='btn btn-primary w-100'
                        onClick={handleSendOnboardingMail}
                        disabled={onboardingLoading}
                      >
                        {onboardingLoading ? (
                          <><span className='spinner-border spinner-border-sm me-2' />Sending...</>
                        ) : (
                          <><KTSVG path='/media/icons/duotune/communication/com005.svg' className='svg-icon-2 me-2' />Send Mail</>
                        )}
                      </button>
                    ) : onboardingLink && (
                      <div className='bg-success bg-opacity-10 rounded p-4'>
                        <div className='d-flex align-items-center gap-2 mb-3'>
                          <KTSVG path='/media/icons/duotune/general/gen043.svg' className='svg-icon-2 svg-icon-success' />
                          <span className='fw-bold text-success'>Email sent & link ready!</span>
                        </div>
                        <label className='form-label fw-semibold'>Onboarding Link</label>
                        <div className='input-group'>
                          <input
                            type='text'
                            className='form-control'
                            value={onboardingLink}
                            readOnly
                          />
                          <button
                            className='btn btn-primary'
                            onClick={() => {
                              navigator.clipboard.writeText(onboardingLink)
                              toast.success('Link copied to clipboard!')
                            }}
                            title='Copy Link'
                          >
                            Copy
                          </button>
                        </div>
                        <p className='text-muted small mt-2 mb-0'>
                          Share this link with the crew member via any channel — WhatsApp, email, etc.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {activeTab === 'documents' && (
              <Documents
                documentForm={documentForm}
                handleDocumentFormChange={handleDocumentFormChange}
                fieldErrors={fieldErrors}
                existingDocument={existingDocument}
                crewId={crewId}
              />
            )}
            {activeTab === 'academic' && (
              <AcademicBackground
                academicBackgrounds={academicBackgrounds}
                handleAcademicBackgroundChange={handleAcademicBackgroundChange}
                handleAddAcademicBackground={handleAddAcademicBackground}
                handleRemoveAcademicBackground={handleRemoveAcademicBackground}
                existingAcademicDetails={existingAcademicDetails}
                fieldErrors={fieldErrors}
              />
            )}
            {activeTab === 'watchkeeping' && (
              <WatchkeepingCertificates
                crewId={crewId}
                watchkeepingCertificates={watchkeepingCertificates}
                handleWatchkeepingCertificateChange={handleWatchkeepingCertificateChange}
                fieldErrors={fieldErrors}
                existingWatchkeepingCertificates={existingWatchkeepingCertificates}
              />
            )}

            {activeTab === 'kin' && (
              <NextOfKin
                nextOfKin={nextOfKin}
                onChange={handleNextOfKinChange}
                onSubmit={handleNextOfKinSubmit}
                errors={fieldErrors}
              />
            )}
            {activeTab === 'courses' && (
              <CoursesCertificates
                crewId={crewId}
                courseCertificates={courseCertificates}
                handleCourseCertificateChange={handleCourseCertificateChange}
                handleAddCourseCertificateRow={handleAddCourseCertificateRow}
                handleRemoveCourseCertificateRow={handleRemoveCourseCertificateRow}
                fieldErrors={fieldErrors}
                existingCourseCertificates={existingCourseCertificates}
              />
            )}

            {activeTab === 'seaService' && (
              <SeaService
                seaServices={seaServices}
                ranks={ranks}
                handleSeaServiceChange={handleSeaServiceChange}
                handleAddSeaService={handleAddSeaService}
                handleRemoveSeaService={handleRemoveSeaService}
                fieldErrors={fieldErrors}
              />
            )}
            {activeTab === 'flagDocs' && (
              <FlagDocuments
                ref={flagDocsRef}
                crewId={crewId}
                fieldErrors={fieldErrors}
                markSaved={() => {
                  setSavedTabs((s) => ({ ...s, flagDocs: true }))
                  setIsFlagsDirty(false)
                }}
                setIsDirty={(dirty) => setIsFlagsDirty(dirty)}
                existingFlagDocuments={existingFlagDocuments}
              />
            )}
            {activeTab === 'banking' && (
              <BankingDetails
                data={bankingDetails}
                onChange={setBankingDetails}
                fieldErrors={fieldErrors}
                onFieldError={(field, error) => {
                  setFieldErrors((prev) => ({
                    ...prev,
                    [field]: error,
                  }))
                }}
              />
            )}
            {activeTab === 'other' && (
              <OtherDetails
                additionalDetails={additionalDetails}
                setAdditionalDetails={setAdditionalDetails}
                references={references}
                setReferences={setReferences}
                existingAdditionalDetails={existingAdditionalDetails}
                companyAwarenessName={companyAwarenessName}
                errors={fieldErrors}
                onSubmit={handleAdditionalDetailsSubmit}
              />
            )}
            {showCrewMatrix && activeTab === 'crewMatrix' && (
              <CrewMatrixProfileModal
                inline
                title='Crew Matrix'
                crewRecord={matrixCrewRecord}
                seaServices={seaServices}
              />
            )}
          </div>
        </div>



        <div className='d-flex gap-2 justify-content-end'>
          <button className='btn btn-secondary mt-4' onClick={onClose}>
            Cancel
          </button>

          {activeTab === 'personal' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button
                className='btn btn-primary'
                onClick={handleSavePersonal}
                disabled={isSubmittingTab || (crewId ? !isPersonalDirty : false)}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {crewId ? 'Save & Next →' : 'Create & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'documents' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('personal')} disabled={isSubmittingTab}>
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleDocumentSubmit}
                disabled={isSubmittingTab || !isDocumentDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {existingDocument?.id ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'academic' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('documents')} disabled={isSubmittingTab}>
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleAcademicSubmit}
                disabled={isSubmittingTab || !isAcademicDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {existingAcademicDetails.length > 0 ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'watchkeeping' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('academic')} disabled={isSubmittingTab}>
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleWatchkeepingSubmit}
                disabled={isSubmittingTab || !isWatchkeepingDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {existingWatchkeepingCertificates.length > 0 ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'kin' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('watchkeeping')} disabled={isSubmittingTab}>
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleNextOfKinSubmit}
                disabled={isSubmittingTab || !isNextOfKinDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {existingNextOfKin?.id ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'courses' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('kin')} disabled={isSubmittingTab}>
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleCourseCertificatesSubmit}
                disabled={isSubmittingTab || !isCoursesDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {existingCourseCertificates?.length > 0 ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'seaService' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('courses')} disabled={isSubmittingTab}>
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleSeaServiceSubmit}
                disabled={isSubmittingTab || !isSeaServiceDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {existingSeaServices?.length > 0 ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'flagDocs' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button
                className='btn btn-light'
                onClick={() => safeSetActiveTab('seaService')}
                disabled={isSubmittingTab}
              >
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleFlagDocsSubmit}
                disabled={isSubmittingTab || !isFlagsDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {savedTabs.flagDocs ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'banking' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('flagDocs')} disabled={isSubmittingTab}>
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleBankingDetailsSubmit}
                disabled={isSubmittingTab || !isBankingDetailsDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {savedTabs.banking ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {activeTab === 'other' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('banking')} disabled={isSubmittingTab}>
                ← Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleAdditionalDetailsSubmit}
                disabled={isSubmittingTab || !isAdditionalDetailsDirty}
              >
                {isSubmittingTab && <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>}
                {existingAdditionalDetails?.id ? 'Update & Next →' : 'Save & Next →'}
              </button>
            </div>
          )}
          {showCrewMatrix && activeTab === 'crewMatrix' && (
            <div className='d-flex gap-2 justify-content-end mt-4'>
              <button className='btn btn-light' onClick={() => safeSetActiveTab('other')}>
                ← Back
              </button>
              <button
                className='btn btn-success'
                onClick={() => {
                  localStorage.removeItem(DRAFT_KEY)
                  onClose()
                }}
              >
                Finish
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AddCrewModal
